const translations = {
  en: {
    session: {
      expiredTitle: "Your session has expired",
      expiredBody: "For your safety you were logged out. Log in again to continue where you left off.",
      loginAgain: "Log in again",
      dismiss: "Dismiss",
    },
    nav: {
      home: "Home",
      useCases: "Use Cases",
      trust: "Trust",
      features: "Features",
      howItWorks: "How It Works",
      pricing: "Pricing",
      howToSetUp: "Setup",
      seeItInAction: "In Action",
      faq: "FAQ",
      corporate: "Corporate",
      login: "Login",
      getStarted: "Get Started",
      seeDemo: "See Demo",
      reportEmergency: "Report Emergency",
      order: "Order",
      scanLogin: "Scan QR",
      signUp: "Sign Up",
      profile: "Profile",
      logout: "Logout",
      myOrders: "My Orders",
      account: "Account",
      signedInAs: "Signed in as",
    },
    hero: {
      badge: "India's Road Safety Initiative",
      trustedBadge: "Trusted by families across India",
      headline: "If You Can't Speak In Emergency, This QR Can.",
      subtitleCalm: "Give Your Family Peace Of Mind. In An Emergency, Anyone Can See Your Blood Type, Allergies, Medications, And Who To Call — Instantly. No App Needed.",
      subtitleNote: "Only what the owner chooses to share.",
      title: "Scan. Report. Save a Life.",
      titleAlt: "In an Emergency, This QR Speaks for You",
      subtitle:
        "Turn any vehicle sticker into a life-saving emergency system. One QR scan connects bystanders to your medical info, emergency contacts, and 112 services instantly.",
      subtitleAlt:
        "Stick a tiny QR code sticker on your phone, helmet or wallet. If something happens to you, anyone can scan it to see your blood type, allergies, medications, and emergency contacts — instantly. No app needed.",
      cta: "Get Your QR Sticker",
      scanCta: "I Already Have a QR Code",
      getQRCta: "Get My QR Code",
      ctaSecondary: "See How It Works",
      check1: "Works Without Any App",
      check2: "Loads in Seconds",
      check3: "One-Time Purchase, Lifetime Use",
      impactLine: "Your scan could save a life in the next 15 minutes",
      stat1Value: "112",
      stat1Label: "Direct ERSS Integration",
      stat2Value: "15 min",
      stat2Label: "Avg. Golden Hour Response",
      stat3Value: "25,000",
      stat3Label: "Gov. Good Samaritan schemes",
    },
    trust: {
      label: "Trusted by families",
      title: "Why Families Trust Us",
      subtitle: "Your Medical Information Deserves The Same Care You'd Give Your Family.",
      t1: "Encrypted & secure",
      t1desc: "AES-256 encryption protects your data at rest and in transit.",
      t2: "Privacy first",
      t2desc: "DPDPA 2023 compliant. You control what's public and what's private.",
      t3: "Built for emergency",
      t3desc: "Critical info loads in seconds when every moment counts.",
      t4: "No app needed",
      t4desc: "Any smartphone camera can read your emergency profile instantly.",
    },
    demo: {
      title: "See It In Action",
      subtitle: "Watch How EmergencyQR Helps In A Real Emergency.",
      imageAlt: "EmergencyQR use cases: road accidents, elderly parents, lost children, and chronic conditions",
      cta: "View Setup Guide",
    },
    howItWorks: {
      badge: "THE PROCESS",
      title: "Buy it. Set it. Stay protected.",
      titleShort: "How To Set Up",
      subtitle: "Three Simple Steps To Protect Yourself And Your Family On Every Journey.",
      setupBadge: "Setup takes under 2 minutes",
      step1Title: "Get your QR sticker",
      step1TitleAlt: "Order Your QR Code",
      step1Desc: "Order your emergency QR sticker starting at just Rs.99. Stick it on your vehicle, helmet, or ID card.",
      step1DescAlt: "We deliver weatherproof QR stickers to your doorstep",
      step1Cta: "Order Now",
      step2Title: "Set up your profile",
      step2TitleAlt: "Add Your Details",
      step2Desc: "Add your blood group, emergency contacts, allergies, and medical conditions. Takes under 2 minutes.",
      step2DescAlt: "Fill in blood type, allergies, medications, and emergency contacts — takes 2 minutes",
      step2Cta: "Setup Guide",
      step3Title: "Stay protected, always",
      step3TitleAlt: "You're Protected",
      step3Desc: "In an emergency, anyone can scan your QR code to access critical info and call 112 instantly.",
      step3DescAlt: "If an emergency happens, anyone who scans the QR code sees your life-saving info instantly",
      step3Cta: "Learn More",
      viewDemo: "See a Live Demo",
      knowMore: "Know More",
    },
    useCases: {
      title: "When Would You Actually Need This?",
      subtitle: "Real situations where a simple QR code can save a life — maybe yours",
      uc1Title: "Road Accidents",
      uc1Desc:
        "You're unconscious after a bike or car accident. The paramedic scans your QR code and immediately knows your blood type is B+, you're allergic to penicillin, and your wife's number. That's the difference this makes.",
      uc1Stat: "Over 1.5 lakh road deaths in India every year",
      uc2Title: "Elderly Parents Living Alone",
      uc2Desc:
        "Your father takes 4 medications daily and lives in another city. If he collapses at the market, the QR sticker on his phone tells anyone exactly who to call and what medicines he's on.",
      uc2Stat: "10 crore+ senior citizens in India",
      uc3Title: "Your Child Gets Lost",
      uc3Desc:
        "Your child wanders off at a crowded mela or mall. A stranger finds them, scans the QR code on their bag or bracelet, and calls you within seconds. No police station, no loudspeaker needed.",
      uc3Stat: "A parent's biggest fear, solved simply",
      uc4Title: "Diabetes, Heart Disease & Allergies",
      uc4Desc:
        "You're diabetic and faint at work. Without this QR code, colleagues might give you sugar water when you actually need insulin. With it, they know exactly what's wrong and who to call.",
      uc4Stat: "7.7 crore+ diabetics in India alone",
      protectCta: "Protect Yourself",
      knowMore: "Know More",
      uc1Detail:
        "India loses over 1.5 lakh lives to road accidents every year. In most cases, the victim is unconscious and unable to communicate critical medical information. An EmergencyQR sticker on your vehicle or helmet allows any bystander or paramedic to instantly access your blood type, allergies, medications, and emergency contacts — no app needed. This bridges the information gap during the Golden Hour and dramatically improves survival chances.",
      uc2Detail:
        "Over 10 crore senior citizens in India live alone or with limited supervision. Many take multiple daily medications and have chronic conditions. A QR code sticker on their phone or wallet ensures that if they collapse in a market, park, or at home, anyone nearby can scan and immediately know who to call, what medicines they take, and what conditions to watch for. It's peace of mind for you and safety for them.",
      uc3Detail:
        "Every parent's nightmare is losing their child in a crowd. With an EmergencyQR sticker on their school bag, bracelet, or ID card, any good samaritan who finds your child can scan the QR code and call you directly within seconds. No loudspeaker announcements, no police station visits — just a quick scan and an instant connection to the parent.",
      uc4Detail:
        "7.7 crore Indians have diabetes, and millions more live with heart disease, severe allergies, or epilepsy. In an emergency, wrong first aid can be fatal — giving sugar to someone who needs insulin, or aspirin to someone allergic to it. An EmergencyQR sticker ensures that anyone helping you knows exactly what's wrong and what NOT to do, potentially saving your life.",
    },
    features: {
      sectionTitle: "Features",
      sectionSubtitle: "When something goes wrong, the right information at the right time can save a life.",
      f1Title: "Scan & See — That's It",
      f1Desc:
        "A bystander or paramedic points their phone camera at your QR code. Your blood type, allergies, medications, and emergency contacts appear instantly on their screen. No app download, no sign-up, no wasted time.",
      f2Title: "All Your Medical Details in One Place",
      f2Desc:
        "Blood group, daily medications, drug allergies, chronic conditions, doctor's number — everything a hospital needs to treat you correctly, stored in one secure profile that you control.",
      f3Title: "Works 24/7, Even When You Can't",
      f3Desc:
        "Emergencies don't follow a schedule. Whether it's 3 AM or during a holiday, your QR code is always ready. As long as the person scanning has a phone and internet, your information is available.",
      f4Title: "You Decide What's Visible",
      f4Desc:
        "Not comfortable sharing everything publicly? No problem. You choose exactly which details are visible to anyone who scans, and which stay private behind your password. Your data is encrypted and never shared without your permission.",
      f5Title: "One for Every Family Member",
      f5Desc:
        "Get a QR code for your parents, your children, or anyone you worry about. Each person gets their own profile with their own medical details. It's the simplest way to look after the people you love.",
      f6Title: "Zero Apps. Zero Hassle.",
      f6Desc:
        "The person helping you doesn't need to download anything. Every modern smartphone can scan a QR code with its built-in camera. One scan opens a simple webpage with your information — that's how easy it is.",
      f1DetailDesc:
        "One scan shows your blood type, allergies, medications, and emergency contacts — no app download needed. Works on any smartphone browser instantly.",
      f1Cta: "Every second counts. Get instant access to life-saving info.",
      f2DetailDesc:
        "Store blood group, allergies, current medications, chronic conditions, and surgical history. Paramedics see what matters most, instantly.",
      f2Cta: "Your medical history could save your life. Store it securely.",
      f3DetailDesc:
        "Your QR sticker works 24/7, 365 days — rain or shine, day or night. No batteries, no charging, no internet needed on the sticker itself.",
      f3Cta: "Always ready when you need it most.",
      f4DetailDesc:
        "You control exactly what information is visible to others. Toggle visibility for each field. Your data is encrypted and stored securely.",
      f4Cta: "Your data, your rules. Full privacy control.",
      f5DetailDesc:
        "Link multiple QR codes under one family account. Monitor elderly parents, children, and family members — all from one dashboard.",
      f5Cta: "Protect your whole family with one account.",
      f6DetailDesc:
        "No app to download, no account needed for the scanner. Any bystander with a phone camera can scan and see emergency info instantly.",
      f6Cta: "Simple enough for anyone to use in a crisis.",
      buyNow: "Buy Now",
      getYoursCta: "Get Yours",
    },
    landing: {
      activeTitle: "Emergency QR Active",
      viewInfo: "View Information",
      ownerLogin: "Owner Login",
      editInfo: "Edit Information",
      matchHolder: "Match with QR code holder",
      matchHolderHint: "Verify the person matches this photo before sharing any emergency info",
    },
    login: {
      title: "Log In",
      password: "Password",
      passwordRequired: "Password is required",
      forgotPassword: "Forgot Password?",
      loggingIn: "Logging in...",
      alreadyLoggedIn: "You're already logged in",
      locked: "Too many failed attempts. Try again in {{time}}.",
    },
    forgotPassword: {
      title: "Forgot Password?",
      emailTab: "Email",
      phoneTab: "Mobile OTP",
    },
    premium: {
      lockedTitle: "Premium feature locked",
      lockedDesc: "Your premium subscription has ended. Renew to unlock this section.",
      upgradeCta: "Renew Premium",
      buyCta: "Upgrade to Premium — ₹199/yr",
      upgradeTitle: "Unlock Premium features",
      upgradeDesc: "Unlimited fields, a medical profile, a 20 MB document vault and an emergency card. More Premium features are coming soon.",
      medicalLockedTitle: "Structured medical profile",
      medicalLockedDesc: "You have saved medical data that is hidden until premium is renewed.",
      expiresOn: "Premium until {{date}}",
      expiresLine: "Premium ({{days}} days left) until {{date}}",
      daysLeft: "{{days}} days left",
      renewMembership: "Renew membership",
      sectionPremiumOnly: "This section is a Premium feature.",
      popupTitle: "Premium features",
      popupIntro: "Included for the first year with every sticker, and again when Premium is renewed.",
      popupClose: "Close",
      popup: {
        f1: "Unlimited emergency information fields",
        f2: "Medical details — allergies, medicines and guardian contacts",
        f3: "Document vault for prescriptions and reports",
        f4: "Downloadable emergency ID card",
        f5: "Scan notifications when someone scans your QR",
        f6: "Offline copy of your emergency information",
        f7: "Priority support",
      },
      teaserScanAlerts: "Premium: instant email & push when someone scans your QR in an emergency",
      teaserMedicalProfile: "Premium: structured allergies, medicines & guardian contacts",
      teaserDocuments: "Premium: secure document vault for prescriptions & reports",
      teaserBloodSos: "Premium: Blood SOS alerts nearby donors in emergencies",
      teaserUnlimitedFields: "Premium: unlimited emergency info fields & sections",
      teaserExportCard: "Premium: export a badge-size emergency card with QR",
    },
    emergencyInfo: {
      title: "Edit QR Information",
      previewPublic: "Preview",
      dragReorder: "Drag fields to reorder. Toggle visibility per field.",
      noItemsYet: "No fields yet. Use + Add above to add information.",
      addField: "Add Field",
    },
    scanner: {
      scanTab: "Scan",
      loginTab: "Login",
      qrIdOrPhone: "QR Code ID or Mobile Number",
      scanTitle: "Scan or Enter QR Code",
    },
    profile: {
      title: "My Profile",
      linkedQR: "Linked QR Codes",
      orderHistory: "Order History",
      noOrders: "No orders yet",
      noQR: "No QR codes linked yet",
      familyDashboardTitle: "Family dashboard",
      familyDashboardDesc:
        "Manage all family QR stickers, track who has set up their profile, and add members from one place.",
      familyDashboardDescWithCount:
        "Your family pack includes {{count}} QR stickers. Open the family dashboard to manage setup for everyone.",
      familyDashboardCta: "Open family dashboard",
      familyMemberIndividualNote:
        "Your QR is part of a family pack. You manage your own profile here; the family account owner manages all stickers from the family dashboard.",
    },
    pricing: {
      title: "Pricing",
      oneTimeTab: "Stickers",
      premiumTab: "Premium renewal",
      oneTimeDesc: "Every Sticker Includes 1 Year Of Premium.",
      premiumDesc: "Extend Premium For Another Year.",
      oneTimeLabel: "one-time",
      inclTaxes: "incl. taxes",
      orderCta: "Order Now",
      launchPrice: "Launch price",
      bestValue: "Best Value",
      perYear: "/year",
      plans: {
        individual: {
          name: "Individual",
          desc: "1 QR Code ID with 2 stickers (1x1 inch)",
          f1: "1 unique QR Code ID",
          f2: "2 weatherproof stickers",
          f3: "1 year premium features free",
          f4: "Unlimited emergency info fields",
          f5: "Free shipping",
        },
        family: {
          name: "Family Pack",
          desc: "4 QR Code IDs with 8 stickers (1x1 inch)",
          f1: "4 unique QR Code IDs",
          f2: "8 weatherproof stickers (2 per ID)",
          f3: "1 year premium features free",
          f4: "Protect parents, kids & yourself",
          f5: "Free shipping",
        },
        premium_yearly: {
          name: "Premium",
          desc: "Advanced features for your emergency QR code",
          f1: "Unlimited info fields",
          f2: "Scan notifications",
          f3: "Document upload",
          f4: "Offline caching",
          f5: "Priority support",
        },
        family_yearly: {
          name: "Family Premium",
          desc: "Premium features for up to 4 QR Code IDs",
          f1: "Unlimited info fields (4 QR IDs)",
          f2: "Scan notifications",
          f3: "Document upload",
          f4: "Offline caching",
          f5: "Priority support",
        },
      },
    },
    orderCheckout: {
      phoneSetupHint:
        "Used for delivery updates and to log in to track this order. The sticker can be set up with any phone number — set it up with this one (and the same password) to see this order in your sticker profile.",
      giftOrderHint:
        "Ordering for someone else? Your number already has a QR, so they'll set up the sticker with their own phone number when they scan it.",
      familyPackHint:
        "You'll get 4 stickers. Each family member sets up their own sticker with their own phone number, and each sticker gets 12 months of Premium from its setup.",
      noPasswordNeeded: "Next, create a password for your account. You'll log in with your mobile number and password to track this order.",
      trackOrder: "Track Your Order",
      goToDashboard: "Go to My Dashboard",
      setupReminder:
        "When the sticker arrives, scan it to set it up with any phone number. To see this order in your sticker profile, set it up with the number you ordered with and the same password. You can always track it by logging in with your order phone number.",
      subscriptionAccountNote:
        "Log in with your mobile number or QR Code ID and password. Premium is added to the QR sticker on your account.",
      subscriptionOwnerLabel: "Account",
      subscriptionPasswordLabel: "Password",
      subscriptionPasswordPlaceholder: "Your account password",
      subscriptionPasswordHint: "Use the password you created when you set up this QR sticker.",
      qrLinkContinueLogin: "Log in to your account",
      qrLinkContinuePayment: "Continue to payment",
      paymentUnavailablePremium:
        "Online payment for premium is being set up. Please try again later or contact support if you need help.",
      paymentUnavailablePhysical:
        "Online payment is being set up. Please use Cash on Delivery for now.",
      paymentTempUnavailablePremium:
        "Online payment is temporarily unavailable. Please try again later.",
      paymentTempUnavailablePhysical:
        "Online payment temporarily unavailable. Please use Cash on Delivery.",
      paymentGatewayFailedPremium:
        "Unable to load the payment gateway. Please try again in a few minutes.",
      paymentGatewayFailedPhysical:
        "Failed to load payment gateway. Please try again or choose Cash on Delivery.",
      paymentPremiumOnlineOnly: "Premium subscriptions require online payment (UPI or card).",
      orderIdLabel: "Your Order ID",
      notificationsSent:
        "We've sent order tracking details to your email. Save your Order ID below.",
      saveOrderId: "Keep this ID handy to track your order anytime.",
      back: "Back",
      continue: "Continue",
      continuePayment: "Continue to payment",
      processing: "Processing…",
      placeOrder: "Place order",
      pay: "Pay",
      stepPlan: "Choose your plan",
      stepShipping: "Shipping details",
      stepAccount: "Create your account",
      accountExists: "An account already exists for {{phone}}. Enter the password to continue.",
      checkingAccount: "Checking this mobile number…",
      stepQr: "Link your QR code",
      stepSignIn: "Sign in",
      stepPayment: "Payment",
      stepConfirmed: "Order Confirmed!",
      stepActivated: "Subscription Activated!",
      progressPlan: "Choose Plan",
      progressShipping: "Shipping",
      progressPayment: "Payment",
      progressQr: "Link QR",
      estimatePlan: "About 2 minutes",
      estimateShipping: "About 60 seconds",
      estimatePayment: "Almost done",
      estimateQr: "About 60 seconds",
      fullName: "Full name",
      nameLabel: "Name",
      nameRequired: "Name is required",
      phoneLabel: "Phone",
      phonePlaceholder: "10-digit number",
      phoneRequired: "Phone is required",
      phoneInvalid: "Valid 10-digit number required",
      cityLabel: "City",
      cityRequired: "City is required",
      pinLabel: "PIN code",
      pinPlaceholder: "6-digit PIN",
      pinRequired: "PIN is required",
      pinInvalid: "Valid 6-digit PIN required",
      addressLabel: "Address",
      addressPlaceholder: "House / flat, building",
      addressRequired: "Address is required",
      areaLabel: "Area / colony",
      areaPlaceholder: "Area or colony",
      areaRequired: "Area is required",
      stateLabel: "State",
      stateRequired: "State is required",
      selectState: "Select state",
      optionalDetails: "Add optional details",
      landmarkLabel: "Landmark",
      optional: "Optional",
      addressLine2: "Address line 2",
      addressLine2Placeholder: "Street, road (optional)",
      stickersTab: "QR & Stickers",
      premiumTab: "Premium",
      stickersHint: "All plans include 1 year of premium features free.",
      premiumHint: "Unlock scan notifications, document upload, and more.",
      yourSelection: "Your selection",
      total: "Total",
      freeShippingTitle: "Free shipping across India",
      freeShippingNote: "Delivered in 5–7 business days",
      shipping: "Shipping",
      free: "Free",
      deliverTo: "Deliver to",
      membershipFor: "Membership for",
      edit: "Edit",
      choosePay: "Choose how to pay",
      preferred: "Preferred",
      notAvailable: "Not available right now",
      agree: "I agree to the",
      terms: "Terms",
      and: "and",
      refund: "Refund policy",
      securePay: "Payments are secure and encrypted",
      cardLabel: "Credit / Debit Card",
      cardSub: "Visa, Mastercard, Rupay, Amex",
      codLabel: "Cash on Delivery",
      codSub: "Pay when you receive the package",
      upiSub: "Google Pay, PhonePe, Paytm, BHIM",
      testMode: "Test mode — use card 4111 1111 1111 1111",
      quantity: "Quantity",
      estimatedDelivery: "Estimated delivery",
      deliveryDays: "5–7 days",
      perYear: "/yr",
    },
    orderPostPurchase: {
      confirmedTitle: "Your order is confirmed 🎉",
      confirmedSubtitle: "Your Emergency QR sticker is now being prepared.",
      estimatedDelivery: "Estimated delivery: 5–7 business days",
      estimatedDeliveryLabel: "Estimated delivery",
      delivered: "Delivered",
      nextSteps: "Next steps",
      copied: "Copied to clipboard",
      trackMyOrder: "Track My Order",
      viewSetupGuide: "View Setup Guide",
      openSetupGuide: "Open Setup Guide",
      whileYouWait: "❤️ While you wait…",
      whileYouWaitSub: "Your sticker will arrive in 5–7 days. Meanwhile, you can already:",
      whileTip1: "Read the Setup Guide",
      whileTip2: "Prepare your emergency information",
      whileTip3: "Gather medication details",
      whileTip4: "Keep emergency contacts ready",
      premiumTitle: "Premium activated! 🎉",
      premiumActive: "Your premium features are now active on your QR code.",
      currentStatus: "Current Status",
      progress: "Progress",
      orderSummary: "Order summary",
      premiumIncluded: "Premium included",
      orderedOn: "Ordered on",
      deliveringTo: "Delivering to",
      deliveryAddress: "Delivery address",
      phone: "Phone",
      mobile: "Mobile",
      qrAssigned: "QR Code assigned",
      setupSticker: "Set up your sticker",
      statusNotify: "We'll email you whenever your order status changes.",
      backToOrder: "Back to orders",
      helpTitle: "Need help?",
      whatsapp: "WhatsApp",
      email: "Email",
      setupGuide: "Setup Guide",
      trackDetails: "Track Details",
      loading: "Loading order details…",
      notFound: "Order not found. Please check the order ID.",
      notFoundTitle: "Order not found",
      step_received: "Order Received",
      step_payment: "Payment received",
      step_printing: "Printing",
      step_packed: "Packed",
      step_shipped: "Shipped",
      step_delivered: "Delivered",
      step_activated: "Activated",
    },
    ctaSection: {
      title: "Get Your QR Code Today",
      subtitle: "One-time purchase. Lifetime use. Set up in under 2 minutes.",
      orderButton: "Order",
    },
    setup: {
      stickerForTitle: "What is this sticker for?",
      stickerForIntro: "Choose how this sticker will be used. Child, pet, and vehicle stickers link to an existing parent/owner account — no new mobile number is added.",
      adultTitle: "Person (Adult)",
      adultDesc: "For yourself or another adult wearer. Creates their login.",
      childTitle: "Person (Child)",
      childDesc: "No new mobile number. Links to the parent account after parent sign-in.",
      petTitle: "Pet",
      petDesc: "Dog, cat, or other pet — sign in as owner.",
      vehicleTitle: "Vehicle",
      vehicleDesc: "Car, bike, or scooter — sign in as owner.",
      title: "Set Up Your QR",
      takes2Min: "Takes 2 minutes",
      continueCta: "Continue — Add Emergency Info",
      creatingAccount: "Creating your account...",
      mobileLabel: "Mobile number",
      emailLabel: "Email",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirm password",
      nameLabel: "Full name",
      addressLabel: "Home address (optional)",
      languageLabel: "Preferred language",
      photoLabel: "Photo of the sticker owner",
      backToChoices: "Back to choices",
      preferNotShare: "Prefer not to share",
    },

    public: {
      medicalInfoTitle: "Emergency Info",
      quickActions: "Quick Actions",
      moreOptions: "More options",
      reportEmergency: "Report Emergency",
      contactThisPerson: "Contact this person",
      ownerValidationNote: "Verify this is the same person before reading their emergency information below.",
      owner: "Owner",
      editInformation: "Edit Information",
      noDetailsTitle: "No Details Added Yet",
      noDetailsDesc:
        "The owner of this QR code hasn't added any emergency information yet. If you are the owner, log in to add your details.",
      loadingDetails: "Loading Medical Details...",
      errorTitle: "Something Went Wrong",
      footerTagline: "EmergencyQR.in | DPDPA 2023 | 112 India",
      reportDisclaimerIntro:
        "This option should be selected only in case of a real emergency, not for playing around or misuse. False reports may have legal consequences.",
      reportDisclaimerLegal: "यह विकल्प केवल वास्तविक आपातकाल में चुनें। गलत रिपोर्ट के गंभीर परिणाम हो सकते हैं।",
      govRecognitionTitle: "Government recognition & rewards",
      govRecognitionDesc:
        "Genuine reports that help save lives may be eligible for government recognition and rewards under state schemes and Good Samaritan guidelines.",
      understandReport: "I understand, Report",
      logout: "Logout",
      freeForeverBadge: "Free forever — no app needed to scan",
      activeMedications: "Active Medications",
      scanConsentEyebrow: "Emergency Assistance",
      scanConsentTitle: "Help Save a Life",
      scanConsentSubtitle: "You're about to assist someone in an emergency.",
      scanConsentDescription:
        "Before we show emergency information, please share your location so the sticker owner can be alerted.",
      scanConsentNote: "Your location is shared only once for this emergency.",
      scanConsentTrust1: "Shared only once",
      scanConsentTrust2: "Not stored permanently",
      scanConsentTrust3: "Never tracked in the background",
      scanConsentHumanNote: "Only continue if you're helping someone during an emergency.",
      scanConsentBody:
        "Only continue if this is a real emergency. Your location will be shared once with the sticker owner. We do not track your location continuously.",
      scanConsentConfirm: "Share My Location",
      scanConsentSecondary: "Continue without location",
      scanConsentLoading: "Sharing your location...",
      scanConsentSuccessTitle: "Location Shared",
      scanConsentSuccessBody: "The sticker owner is being notified.",
      scanConsentSuccessNext: "Opening emergency profile...",
      scanConsentPrivacyLink: "Why do we need your location?",
      scanConsentPrivacyTitle: "Why we ask for location",
      scanConsentPrivacyBody:
        "When you scan an EmergencyQR sticker, the owner can be alerted that help may be needed. We use your location once — at this moment only — so they know where the scan happened. Emergency contacts are notified separately if you call them from the profile. EmergencyQR does not track you afterward.",
      scanConsentCall108: "Need to call an ambulance instead?",
      scanConsentCall108Link: "Call 108",
      essentialCardBadge: "Emergency essentials",
      essentialCardSubtitle: "Critical info for first responders",
      notProvided: "Not provided",
      essentialIncompleteHint: "Owner has not filled all essential fields yet. Use helplines below if needed.",
      callPrimary: "Call Emergency Contact",
      directCallNote: "Direct dial — call masking is a premium feature (coming soon).",
      noPrimaryContact: "No emergency contact on file. Use national helplines below.",
      otherContacts: "Other Emergency Contacts",
      helplineTitle: "India Emergency Numbers",
      helplineSubtitle: "Tap to call — works without internet",
      helpline112: "National ERSS",
      helpline108: "Ambulance",
      helpline1098: "Childline",
      helpline181: "Women's Helpline",
      helpline1098Desc: "1098 — Child in distress or missing (बाल सहायता)",
      helpline181Desc: "181 — Women in distress / domestic violence",
      helplineFootnote: "112 for accidents & rescue · 108 for medical ambulance · 1098 for children · 181 for women",
      reportEmergencySub: "Share location & optional video evidence",
      guidedRescue: "Guided Rescue (DRABC)",
      guidedRescueSub: "Step-by-step first aid for bystanders",
      nearbyServices: "Nearby Hospitals & Blood Banks",
      nearbyServicesSub: "Find help close to you",
      findMyReport: "Find My Emergency Report",
      findMyReportSub: "View video you recorded as a bystander",
      resumeReportBanner: "You have a recent emergency report on this device — tap to continue",
      additionalInfo: "Additional Information",
      tabEssentials: "Essentials",
      tabActions: "Actions",
      tabMedical: "Medical",
      tabDetails: "More Info",
      premiumSectionLocked: "Premium content locked",
      premiumSectionLockedDesc: "Renew premium to view this information.",
      premiumFieldLocked: "Premium — renew to unlock",
      callConfirmTitle: "Call emergency contact?",
      callNow: "Call Now",
      callConfirmBody: "Calling {{name}} for {{owner}}. Only proceed in a real emergency.",
      callRevealTitle: "Emergency call",
      callRevealLocationIntro:
        "Please enable location when your phone asks. Sharing where you are helps emergency contacts reach this person faster. Highly recommended.",
      callRevealLocationPrompt:
        "Tap below. Your phone will show a location permission menu—choose Allow or While using the app if you can.",
      callRevealLocationWaiting: "Waiting for your location choice on this phone…",
      callRevealLocationDenied: "Location was not shared. You can still place the call.",
      callRevealLocationTimeout: "Location timed out. You can still place the call.",
      callRevealContinue: "Continue",
      callRevealShareLocation: "Share my location",
      callRevealSkipLocation: "Call without location",
      callRevealBody:
        "You are initiating an emergency call. Location and device details are logged for security.",
      callRevealContact: "Calling {{name}}",
      callRevealWorking: "Connecting your call…",
      callRevealDialNow: "Call {{name}} now",
      callRevealDialHint: "Tap the button below once to open your phone dialer. Location is already shared with emergency contacts.",
      bystanderMedicalHeading: "Important for helpers",
      callRevealModeTitle: "Emergency call privacy",
      callRevealModeExpress: "Express Emergency (recommended)",
      callRevealModeExpressDesc: "One-tap confirmation, then your contact's number opens in the dialer. Alerts go to you and your emergency contact.",
      callRevealModeVerified: "Verified Bystander (coming soon)",
      callRevealModeVerifiedDesc: "Bystander verifies their mobile before the number is revealed. Reduces prank scans.",
      goodSamaritanTitle: "Good Samaritan Protection",
      goodSamaritanSubtitle: "Legal immunity when helping accident victims",
      goodSamaritanPoint1: "You cannot be forced to be a witness or detained by police for helping.",
      goodSamaritanPoint2: "Hospitals cannot refuse emergency treatment or demand payment upfront from helpers.",
      goodSamaritanPoint3: "Document your help via Report Emergency + Guided Rescue for reward claims.",
      goodSamaritanPoint3Paused:
        "Report Emergency and Guided First Aid help you assist safely while professional help is on the way.",
      rahVeerInfoTitle: "Government RaH-Veer / Good Samaritan recognition",
      rahVeerInfoBody:
        "The Government of India encourages bystanders who help road accident victims. Under Good Samaritan guidelines and state RaH-Veer or PM-RAHAT schemes, helpers may receive recognition (often up to ₹25,000) and legal protection when they follow official procedures. Apply through your state transport department or the 112 ERSS portal — in-app reward claims are not available yet.",
      rahVeerTitle: "RaH-Veer / PM-RAHAT Reward (Up to ₹25,000)",
      rahVeerHowTo:
        "After helping at a road accident, you may claim recognition under Good Samaritan guidelines and PM-RAHAT / state RaH-Veer schemes:",
      rahVeerStep1: "Call 112 and ensure the victim reaches a PM-RAHAT empanelled hospital.",
      rahVeerStep2: "Complete Report Emergency + record video evidence on this page.",
      rahVeerStep3: "Finish Guided Rescue (DRABC) steps — documents your Good Samaritan actions.",
      rahVeerStep4: "Apply via your state transport department / 112 ERSS portal with report ID and hospital records.",
      startGuidedRescue: "Start Guided Rescue",
      goodSamaritanLink: "MoRTH Good Samaritan guidelines",
      lookupTitle: "Find emergency report",
      lookupSubtitle: "For bystanders who filed a report",
      lookupIntro:
        "Verify your mobile number with OTP to view your recorded video and continue guided rescue. OTP is required when returning later — not right after you submit.",
      lookupPhone: "Your mobile number",
      lookupPhonePlaceholder: "10-digit mobile number",
      lookupPhoneHint: "Use the same number you entered when reporting the emergency.",
      lookupPhoneInvalid: "Enter a valid 10-digit Indian mobile number.",
      lookupSendOtp: "Send OTP",
      lookupOtp: "Enter OTP",
      lookupOtpSent: "OTP sent to",
      lookupVerifyOtp: "Verify OTP",
      lookupChangePhone: "Change phone number",
      lookupOtpInvalid: "Enter the 6-digit verification code.",
      lookupOtpSendFailed: "Could not send OTP. Try again in a few minutes.",
      lookupOtpVerifyFailed: "Invalid or expired OTP.",
      lookupSmsUnavailable:
        "Verification codes are not available right now. Email support@emergencyqr.in if you need to access a report.",
      lookupYourReports: "Your reports for this QR code",
      lookupHasVideo: "Has video",
      lookupNoReports: "No reports found for this phone on this QR code.",
      lookupBackToList: "Back to report list",
      lookupLoadingVideo: "Loading video…",
      lookupReportId: "Report ID",
      lookupFailed: "Could not load report.",
      lookupLoading: "Loading…",
      lookupFound: "Report found",
      lookupLocation: "Location",
      lookupVideo: "Recorded evidence",
      lookupNoVideo: "No video was attached to this report.",
      continueRescue: "Continue guided rescue",
      backToProfile: "Back to emergency card",
      lookupView: "View",
      emergencySnapshot: "Emergency Snapshot",
      infoVerified: "Information Verified",
      lastUpdated: "Last Updated",
      notAvailable: "Not Available",
      shareLocation: "Share Location",
      shareLocationSub: "Send your GPS pin",
      reportEmergencySubShort: "Alert & record evidence",
      guidedRescueSubShort: "Step-by-step first aid",
      nearbyServicesSubShort: "Hospitals & blood banks",
      findMyReportSubShort: "View saved video",
      uploadEvidence: "Upload Evidence",
      callPrimaryContact: "Call Primary Contact",
      bloodGroupLabel: "Blood Group",
      allergiesLabel: "Allergies",
      conditionsLabel: "Medical Conditions",
      primaryContactLabel: "Primary Emergency Contact",
      emergencyContacts: "Emergency Contacts",
      medicalInformation: "Medical Information",
      personalInformation: "Personal Information",
      emergencyDetails: "Emergency Details",
      otherInformation: "Other Information",
      fieldName: "Name",
      fieldAge: "Age",
      fieldGender: "Gender",
      fieldAddress: "Address",
      fieldLanguage: "Preferred Language",
      fieldInsurance: "Insurance",
      fieldDoctor: "Doctor",
      fieldHospital: "Preferred Hospital",
      fieldGenderMale: "Male",
      fieldGenderFemale: "Female",
      ageYears: "Years",
      noPhoto: "No Photo",
      tapToEnlarge: "Tap Photo to Enlarge",
      verifyPhotoHint: "Match the photo with the person before using this information.",
      verifyPhotoHintPet: "Match the photo with the pet before using this information.",
      verifyPhotoHintVehicle: "Match the photo with the vehicle before using this information.",
      verifyNoPhotoHint: "No photo added. Confirm the name, age and gender before using this information.",
      verifyNoPhotoHintPet: "No photo added. Confirm the pet's name and details before using this information.",
      verifyNoPhotoHintVehicle: "No photo added. Confirm the vehicle details before using this information.",
      closePhoto: "Close Photo",
      ownerPhotoAlt: "Photo of {{name}}",
      quickReport: "Report Emergency",
      quickFirstAid: "First Aid Steps",
      quickNearby: "Nearby Hospitals",
      quickShare: "Share Location",
      quickFindReport: "My Report",
      sosEmergency: "Emergency",
      sosAmbulance: "Ambulance",
      sosPolice: "Police",
      sosWomen: "Women",
      sosBarLabel: "India Emergency Numbers",
      noPrimaryContactShort: "No Contact Added",
      footerDpdpa: "DPDPA 2023 compliant · data shared only for emergency response",
      footerEmergency: "For life-threatening emergencies in India, dial 112 or 108",
    },
    value: {
      badge: "WHY IT MATTERS",
      title: "Every second counts. Every scan saves.",
      subtitle:
        "In India, over 1.5 lakh people die in road accidents annually. The first 60 minutes - the Golden Hour - determine survival. EmergencyQR bridges the gap between accident and ambulance.",
      stat1: "1.5 Lakh+",
      stat1Label: "Annual road deaths in India",
      stat2: "60 min",
      stat2Label: "The critical Golden Hour",
      stat3: "50%",
      stat3Label: "Lives saveable with timely first aid",
    },
    benefits: {
      badge: "THE BENEFITS",
      title: "Safety You Can Count On.",
      subtitle: "Everything You Need To Protect Yourself And Help Others On The Road.",
      b1Title: "Instant Emergency Access",
      b1Desc: "One scan reveals blood group, allergies, emergency contacts, and medical conditions to any bystander.",
      b2Title: "Direct 112 Integration",
      b2Desc: "Built-in buttons to call ERSS (112), Ambulance (108), and Police (100) with auto-location sharing.",
      b3Title: "Guided First Aid",
      b3Desc: "Step-by-step DRABC protocol and CPR instructions keep bystanders productive during the Golden Hour.",
      b4Title: "Good Samaritan protection",
      b4Desc:
        "India's Good Samaritan rules protect helpers at accident scenes. State RaH-Veer / PM-RAHAT schemes may offer government recognition — see MoRTH and your state transport department.",
      b5Title: "Family Pack",
      b5Desc: "4 stickers for parents, children and spouse. Each person sets up their own sticker with their own phone.",
      b6Title: "DPDPA Compliant",
      b6Desc: "Your medical data is encrypted with AES-256 and protected under India's Digital Personal Data Protection Act.",
    },
    testimonials: {
      badge: "REAL IMPACT",
      title: "Stories That Save Lives.",
      subtitle: "Real Families And Fleet Managers Share How EmergencyQR Made A Difference When Seconds Mattered.",
      t1Quote:
        "A bystander scanned my son's QR sticker after his bike accident. The ambulance reached in 12 minutes because they had his blood group and location instantly.",
      t1Name: "Priya Sharma",
      t1Role: "Mother, Delhi",
      t2Quote:
        "As a delivery rider covering 100km daily, this sticker gives me and my family peace of mind. The setup took less than 2 minutes.",
      t2Name: "Ravi Kumar",
      t2Role: "Delivery Partner, Bangalore",
      t3Quote:
        "We deployed EmergencyQR across our 500-vehicle fleet. Response times improved by 40% and our insurance costs dropped significantly.",
      t3Name: "Anita Desai",
      t3Role: "Fleet Manager, Mumbai",
    },
    guide: {
      back: "Back to Home",
      backShort: "Home",
      navOrder: "Order Your QR Sticker {{price}}",
      needHelp: "Need Help?",
      shareWhatsApp: "Share on WhatsApp",
      badge: "SOS",
      title: "Emergency QR Setup Guide",
      subtitleBefore: "Set up your QR in less than",
      subtitleHighlight: "two minutes.",
      readTime: "Estimated time: 2 minutes",
      download: "Download PDF",
      downloading: "Preparing PDF…",
      progressLabel: "Guide progress",
      stepTime: "{{time}}",
      hindiLabel: "हिंदी",
      steps: {
        s1: {
          title: "What is this QR code sticker?",
          imageAlt: "Indian family holding an Emergency QR sticker",
          titleHi: "यह QR स्टिकर क्या है?",
          body: "A small waterproof sticker with a unique QR code. When anyone scans it with their phone, they instantly see your emergency information — no app required.",
          bodyHi:
            "यह एक छोटा वॉटरप्रूफ स्टिकर है जिस पर अनोखा QR कोड है। कोई भी मोबाइल से स्कैन करे तो तुरंत आपकी आपातकालीन जानकारी दिखती है — कोई ऐप जरूरी नहीं।",
          time: "20 sec",
          highlights: [],
        },
        s2: {
          title: "Scan the QR code",
          imageAlt: "Scanning a QR code on a helmet with a smartphone",
          titleHi: "QR कोड कैसे स्कैन करें",
          body: "Open the camera on any Android or iPhone and point it at the QR code. Tap the link that appears — your emergency profile opens instantly.",
          bodyHi:
            "किसी भी Android या iPhone पर कैमरा खोलें और QR कोड पर पॉइंट करें। स्क्रीन पर दिखने वाले लिंक पर टैप करें — आपकी प्रोफाइल तुरंत खुल जाती है।",
          time: "15 sec",
          highlights: [],
        },
        s3: {
          title: "Set up your information",
          imageAlt: "Setting up emergency profile on a smartphone",
          titleHi: "अपनी जानकारी सेट करें",
          body: "Scan your sticker and tap Set Up. Add your Blood Group, Allergies, Medications, and Emergency Contact — it takes about two minutes.",
          bodyHi:
            "अपना स्टिकर स्कैन करें और 'सेट अप' पर टैप करें। ब्लड ग्रुप, एलर्जी, दवाइयां और आपातकालीन संपर्क जोड़ें — लगभग दो मिनट लगते हैं।",
          time: "45 sec",
          highlights: ["Blood Group", "Allergies", "Medications", "Emergency Contact"],
          highlightsHi: ["ब्लड ग्रुप", "एलर्जी", "दवाइयां", "आपातकालीन संपर्क"],
        },
        s4: {
          title: "In an emergency",
          imageAlt: "Bystander scanning QR code during a roadside emergency",
          titleHi: "आपातकाल में क्या होता है",
          body: "If you are injured or unconscious, any passerby or paramedic scans your sticker and immediately sees your Blood Group, emergency contacts, and medical conditions.",
          bodyHi:
            "अगर आप घायल या बेहोश हैं, कोई भी राहगीर या पैरामेडिक आपका स्टिकर स्कैन करके तुरंत ब्लड ग्रुप, आपातकालीन संपर्क और बीमारियां देख सकता है।",
          time: "20 sec",
          highlights: ["Blood Group"],
          highlightsHi: ["ब्लड ग्रुप"],
        },
        s5: {
          title: "Suggested information to add",
          imageAlt: "Emergency profile showing blood group, allergies, and contacts",
          titleHi: "जोड़ने के लिए सुझाई गई जानकारी",
          body: "Blood Group, doctor's phone number, daily Medications, known Allergies, and an Emergency Contact (family member). The more complete your profile, the faster help arrives.",
          bodyHi:
            "ब्लड ग्रुप, डॉक्टर का फोन नंबर, रोज़ की दवाइयां, ज्ञात एलर्जी और आपातकालीन संपर्क (परिवार का सदस्य)। जितनी पूरी प्रोफाइल, उतनी तेज़ मदद।",
          time: "30 sec",
          highlights: ["Blood Group", "Medications", "Allergies", "Emergency Contact"],
          highlightsHi: ["ब्लड ग्रुप", "दवाइयां", "एलर्जी", "आपातकालीन संपर्क"],
        },
      },
      cta: {
        title: "Protect your family today",
        subtitle: "Get your Emergency QR sticker and be prepared for any emergency.",
        order: "Order Your QR Sticker",
        demo: "See Demo",
        priceNote: "Starting at {{price}}",
        completeBadge: "You're Ready",
        completeLead: "You now know how EmergencyQR works.",
        completeBody: "Protect yourself and your family for just {{price}}.",
        trust1: "One-time purchase",
        trust2: "12 months Premium included",
        trust3: "Free info stays forever",
        trustSocial: "Trusted by families across India",
      },
      footer: {
        title: "Still have questions?",
        helpNote: "We're here to help you.",
        contact: "Contact us",
        whatsapp: "Chat on WhatsApp",
        email: "Email Us",
        emailAddress: "support@emergencyqr.in",
        responseNote: "We respond within 24 hours",
      },
    },
    faq: {
      badge: "Know More",
      title: "Frequently Asked Questions",
      subtitle: "Everything You Need To Know Before You Order Your Emergency QR Sticker.",
      q1: "How does EmergencyQR work?",
      a1: "You receive a durable QR sticker that you place on your vehicle, helmet, or ID card. When scanned by anyone, it displays your emergency medical information, contacts, and provides one-tap access to call 112, 108 (Ambulance), and 100 (Police).",
      q2: "What information should I add to my profile?",
      a2: "We recommend adding your blood group, known allergies, medical conditions (diabetes, heart conditions, etc.), emergency contacts with phone numbers, and your preferred hospital. You control what is visible to scanners.",
      q3: "Is my medical data safe?",
      a3: "All medical data is encrypted with AES-256-GCM encryption at rest. We comply with DPDPA 2023 (India's Data Protection Act). You can control visibility of each piece of information and delete your profile at any time.",
      q4: "What is the Rah-Veer reward?",
      a4: "Under India's Good Samaritan Rules, bystanders who help accident victims may be eligible for state RaH-Veer or PM-RAHAT recognition (often up to ₹25,000) and legal protection when they follow official guidelines. Claims are handled by state authorities and 112 ERSS — not through EmergencyQR at this time.",
      q5: "Can I manage profiles for my family?",
      a5: "Yes. The Family Pack has 4 stickers. Each family member scans their own sticker and sets it up with their own phone number, so every sticker has its own profile. Each one gets 12 months of Premium from the day it is set up, and Family Premium renews up to 4 stickers together.",
      q6: "How much does it cost?",
      a6Individual: "Individual stickers are",
      a6IndividualTail: "at the launch price, with 12 months of Premium.",
      a6Family: "Family packs (4 stickers) are",
      a6End: ". No hidden fees, no recurring charges for the first year.",
    },
    cta: {
      badge: "START NOW",
      title: "Protect yourself. Help others.",
      subtitle:
        "Join thousands of Indian drivers, riders, and families who have already made their journeys safer with EmergencyQR.",
      button: "Get Your QR Sticker - Rs.99",
    },
    footer: {
      tagline: "India's emergency QR code system for road safety.",
      howItWorks: "How It Works",
      pricing: "Plans",
      corporate: "Corporate",
      about: "About Us",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "EmergencyQR. All rights reserved.",
      dpdpa: "DPDPA 2023 Compliant",
      madeIn: "Made in India",
    },
    emergency: {
      reportTitle: "Report Emergency",
      reportSubtitle: "आपातकाल की रिपोर्ट करें",
      viewInfo: "View Information",
      viewInfoHi: "जानकारी देखें",
      ownerLogin: "Owner Login",
      ownerLoginHi: "मालिक लॉगिन",
      step1: "Confirm Location",
      step1Hi: "स्थान की पुष्टि करें",
      step2: "Type of Emergency",
      step2Hi: "आपातकाल का प्रकार",
      step3: "Record Evidence",
      step3Hi: "साक्ष्य रिकॉर्ड करें",
      step4: "Your Phone Number",
      step4Hi: "आपका फोन नंबर",
      medical: "Medical",
      medicalHi: "चिकित्सा",
      accident: "Accident",
      accidentHi: "दुर्घटना",
      fire: "Fire / Other",
      fireHi: "आग / अन्य",
      call112: "Call 112 - National Emergency",
      call112Hi: "112 कॉल करें - राष्ट्रीय आपातकाल",
      call108: "Call 108 - Ambulance",
      call108Hi: "108 कॉल करें - एम्बुलेंस",
      call100: "Call 100 - Police",
      call100Hi: "100 कॉल करें - पुलिस",
      capturingLocation: "Capturing your location...",
      capturingLocationHi: "आपका स्थान प्राप्त कर रहे हैं...",
      locationCaptured: "Location captured successfully",
      locationCapturedHi: "स्थान सफलतापूर्वक प्राप्त हुआ",
      locationFailed: "Could not get location. Please enter manually.",
      locationFailedHi: "स्थान प्राप्त नहीं हो सका। कृपया मैन्युअल रूप से दर्ज करें।",
      tapToReport: "Tap to report emergency",
      tapToReportHi: "आपातकाल की रिपोर्ट करने के लिए टैप करें",
      videoReward:
        "Record a 10-second video to qualify for a FREE QR code, 3 months membership, and government Rah-Veer reward of Rs.25,000",
      videoRewardHi:
        "मुफ्त QR कोड, 3 महीने की सदस्यता और सरकारी राह-वीर पुरस्कार Rs.25,000 के लिए 10 सेकंड का वीडियो रिकॉर्ड करें",
      phoneRequired: "Phone number required for callback and reward claim",
      phoneRequiredHi: "कॉलबैक और पुरस्कार दावे के लिए फोन नंबर आवश्यक",
      submitReport: "Submit Emergency Report",
      submitReportHi: "आपातकालीन रिपोर्ट जमा करें",
      needLocationDesc: "We need your location to dispatch emergency services quickly.",
      needLocationDescHi: "आपातकालीन सेवाओं को तुरंत भेजने के लिए हमें आपका स्थान चाहिए।",
      manualAddressLabel: "Manual Address (optional)",
      manualAddressLabelHi: "पता मैन्युअल रूप से दर्ज करें (वैकल्पिक)",
      manualAddressPlaceholder: "Enter landmark, road name, or area...",
      manualAddressPlaceholderHi: "लैंडमार्क, सड़क का नाम या इलाका दर्ज करें...",
      nextSelectType: "Next - Select Emergency Type",
      nextSelectTypeHi: "अगला - आपातकाल प्रकार चुनें",
      tryAgain: "Try Again",
      tryAgainHi: "पुनः प्रयास करें",
      selectTypeDesc: "Selecting a type will call the number. Tap to call now.",
      selectTypeDescHi: "प्रकार चुनने पर नंबर डायल होगा। अभी कॉल करने के लिए टैप करें।",
      callInitiated: "Call initiated",
      callInitiatedHi: "कॉल शुरू हो गया",
      callInitiatedTo: "Call initiated to",
      callInitiatedToHi: "कॉल शुरू हो गया",
      continueNext: "Continue to next step →",
      continueNextHi: "अगले चरण पर जाएं →",
      recordEvidenceOptional: "Record Evidence (Optional)",
      recordEvidenceOptionalHi: "साक्ष्य रिकॉर्ड करें (वैकल्पिक)",
      earnRewards: "Earn Rewards!",
      earnRewardsHi: "पुरस्कार कमाएं!",
      startRecording: "Start Recording",
      startRecordingHi: "रिकॉर्डिंग शुरू करें",
      stopRecording: "Stop Recording",
      stopRecordingHi: "रिकॉर्डिंग रोकें",
      recordAgain: "Record Again",
      recordAgainHi: "फिर से रिकॉर्ड करें",
      videoRecorded: "Video recorded successfully!",
      videoRecordedHi: "वीडियो सफलतापूर्वक रिकॉर्ड हुआ!",
      tapToStartRecording: "Tap below to start 10-second recording",
      tapToStartRecordingHi: "10 सेकंड की रिकॉर्डिंग शुरू करने के लिए नीचे टैप करें",
      cameraDenied: "Camera access denied or unavailable.",
      cameraDeniedHi: "कैमरा एक्सेस अस्वीकृत या अनुपलब्ध।",
      skip: "Skip",
      skipHi: "छोड़ें",
      next: "Next",
      nextHi: "अगला",
      yourPhoneNumber: "Your Phone Number",
      yourPhoneNumberHi: "आपका फोन नंबर",
      phoneRequiredDesc: "Required for callback verification and reward claim.",
      phoneRequiredDescPaused: "Required so emergency contacts or responders can reach you if needed.",
      phoneRequiredDescHi: "कॉलबैक सत्यापन और पुरस्कार दावे के लिए आवश्यक।",
      phoneRequiredDescPausedHi: "जरूरत पड़ने पर आपातकालीन संपर्क आप तक पहुंच सकें, इसके लिए आवश्यक।",
      phoneLabel: "Phone Number",
      phoneLabelHi: "फोन नंबर",
      enterPhonePlaceholder: "Enter 10-digit number",
      enterPhonePlaceholderHi: "10 अंकों का नंबर दर्ज करें",
      phonePrivacyNote: "Your number will only be used for emergency callback and reward verification.",
      phonePrivacyNotePaused: "Your number is used only for emergency follow-up related to this report.",
      phonePrivacyNoteHi: "आपका नंबर केवल आपातकालीन कॉलबैक और पुरस्कार सत्यापन के लिए उपयोग किया जाएगा।",
      phonePrivacyNotePausedHi: "आपका नंबर केवल इस रिपोर्ट से जुड़े आपातकालीन फॉलो-अप के लिए उपयोग होगा।",
      submitting: "Submitting...",
      submittingHi: "जमा हो रहा है...",
      reportSubmitted: "Report Submitted",
      reportSubmittedHi: "रिपोर्ट जमा हो गई",
      redirecting: "Redirecting to first aid guide...",
      redirectingHi: "प्राथमिक चिकित्सा मार्गदर्शन पर रीडायरेक्ट हो रहा है...",
      rahVeerEligible: "Rah-Veer Reward Eligible!",
      rahVeerEligibleHi: "राह-वीर पुरस्कार के पात्र!",
      rewardAmount: "Rs.25,000 + Legal Immunity",
      rewardAmountHi: "Rs.25,000 + कानूनी प्रतिरक्षा",
      emergency112: "112 Emergency",
      emergency112Hi: "112 आपातकाल",
      locationUnavailable: "Location unavailable",
      locationUnavailableHi: "स्थान अनुपलब्ध",
      submitError: "Failed to submit report. Please try again.",
      submitErrorHi: "रिपोर्ट जमा करने में विफल। कृपया पुनः प्रयास करें।",
      phoneValidationDigits: "Phone number must be 10 digits",
      phoneValidationDigitsHi: "फोन नंबर 10 अंकों का होना चाहिए",
      phoneValidationStart: "Must start with 6, 7, 8, or 9",
      phoneValidationStartHi: "6, 7, 8 या 9 से शुरू होना चाहिए",
      indiaEmergencyNumbers: "India emergency numbers (भारत आपातकाल नंबर):",
      indiaEmergencyNumbersHi: "भारत आपातकाल नंबर:",
      number112Desc: "112 — National single emergency number (accidents, rescue, any emergency)",
      number108Desc: "108 — Ambulance (medical emergency)",
      number100Desc: "100 — Police",
    },
    rescue: {
      title: "Guided First Aid",
      titleHi: "प्राथमिक चिकित्सा मार्गदर्शन",
      subtitle: "Follow these steps while waiting for the ambulance",
      subtitleHi: "एम्बुलेंस की प्रतीक्षा करते हुए इन चरणों का पालन करें",
      rewardBanner: "You are acting as a Rah-Veer! Eligible for Rs.25,000 reward + legal immunity",
      rewardBannerHi: "आप राह-वीर के रूप में कार्य कर रहे हैं! Rs.25,000 पुरस्कार + कानूनी प्रतिरक्षा के पात्र",
      danger: "DANGER",
      dangerHi: "खतरा",
      dangerDesc: "Check if the area is safe for you to approach. Look for traffic, fire, or electrical hazards.",
      dangerDescHi: "जांचें कि क्या क्षेत्र आपके पास जाने के लिए सुरक्षित है। यातायात, आग या बिजली के खतरों की तलाश करें।",
      response: "RESPONSE",
      responseHi: "प्रतिक्रिया",
      responseDesc: "Gently tap the person's shoulders and ask loudly: 'Are you okay? Can you hear me?'",
      responseDescHi: "धीरे से व्यक्ति के कंधों को थपथपाएं और जोर से पूछें: 'क्या आप ठीक हैं? क्या आप मुझे सुन सकते हैं?'",
      airway: "AIRWAY",
      airwayHi: "वायुमार्ग",
      airwayDesc:
        "Tilt the head back gently and lift the chin to open the airway. Remove any visible obstructions from the mouth.",
      airwayDescHi: "सिर को धीरे से पीछे झुकाएं और ठुड्डी को ऊपर उठाएं। मुंह से दिखाई देने वाली किसी भी रुकावट को हटाएं।",
      breathing: "BREATHING",
      breathingHi: "श्वास",
      breathingDesc:
        "Look at the chest for movement, listen for breath sounds, and feel for air on your cheek for 10 seconds.",
      breathingDescHi: "10 सेकंड तक छाती की गति देखें, सांस की आवाज सुनें, और अपने गाल पर हवा महसूस करें।",
      circulation: "CIRCULATION",
      circulationHi: "रक्त संचार",
      circulationDesc: "Check for severe bleeding. If bleeding, apply firm, continuous pressure with a clean cloth.",
      circulationDescHi: "गंभीर रक्तस्राव की जांच करें। यदि खून बह रहा है, तो साफ कपड़े से मजबूत, निरंतर दबाव लगाएं।",
      cprTitle: "CPR Instructions",
      cprTitleHi: "सीपीआर निर्देश",
      cprDesc:
        "If not breathing: Push hard and fast in the center of the chest. 30 compressions, then 2 rescue breaths. Repeat.",
      cprDescHi: "यदि सांस नहीं चल रही: छाती के बीच में जोर से और तेज दबाएं। 30 दबाव, फिर 2 बचाव श्वास। दोहराएं।",
      bleedingTitle: "Bleeding Control",
      bleedingTitleHi: "रक्तस्राव नियंत्रण",
      bleedingDesc:
        "Apply direct, continuous pressure with a clean cloth. Do NOT remove the cloth. Add more layers if needed.",
      bleedingDescHi: "साफ कपड़े से सीधा, निरंतर दबाव लगाएं। कपड़ा न हटाएं। जरूरत हो तो और परतें जोड़ें।",
      fractureTitle: "Fracture Support",
      fractureTitleHi: "फ्रैक्चर सहायता",
      fractureDesc:
        "Support the injured limb with a wooden block, umbrella, or rolled newspaper. Do NOT try to straighten the limb.",
      fractureDescHi: "घायल अंग को लकड़ी के ब्लॉक, छतरी या मुड़े हुए अखबार से सहारा दें। अंग को सीधा करने की कोशिश न करें।",
      neckWarning:
        "NEVER move an unconscious person without supporting their neck. Spinal injuries can cause permanent paralysis.",
      neckWarningHi:
        "बेहोश व्यक्ति को गर्दन को सहारा दिए बिना कभी न हिलाएं। रीढ़ की हड्डी की चोटें स्थायी पक्षाघात का कारण बन सकती हैं।",
      completed: "Done",
      completedHi: "पूरा हुआ",
      primarySurveyTitle: "Primary Survey (DRABC)",
      primarySurveySubtitle: "Follow each step in order",
      criticalInterventions: "Critical Interventions",
      goldenHourSubtitle: "Golden Hour actions",
      markAsDone: "Mark as Done",
      rewardEligibleShort: "Eligible for Rs.25,000 reward + complete legal immunity",
      completeMoreSteps: "Complete {{n}} more steps for Rah-Veer status",
      disclaimer: "Instructions based on MoHFW & St. John Ambulance protocols. In case of doubt, wait for professional help.",
      poweredBy: "Powered by EmergencyQR.in",
      typeMedical: "Medical Emergency — Focus on CPR & Breathing",
      typeAccident: "Accident — Focus on Bleeding Control",
      typeFire: "Fire/Other — Check for Burns & Bleeding",
      whatsappNotify: "Notify via WhatsApp",
      showAllSteps: "Show all steps",
      showLess: "Show less",
    },
    family: {
      title: "Family Dashboard",
      subtitle: "Manage emergency profiles for your entire family",
      addMember: "Add Family Member",
      memberName: "Member Name",
      relationship: "Relationship",
      qrId: "QR Code ID",
      self: "Self",
      spouse: "Spouse",
      parent: "Parent",
      child: "Child",
      other: "Other",
      noMembers: "No family members added yet. Add your first family member to get started.",
      login: "Family Login",
      register: "Create Family Account",
      email: "Email Address",
      password: "Password",
      phone: "Phone Number",
      name: "Your Name",
    },
    shared: {
      loading: "Loading...",
      loadingHi: "लोड हो रहा है...",
      error: "Something went wrong",
      errorHi: "कुछ गलत हो गया",
      back: "Back",
      next: "Next",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      poweredBy: "Powered by EmergencyQR.in",
      dpdpaCompliant: "DPDPA 2023 Compliant",
      erssIntegration: "112 India Integration",
    },
  },
  hi: {
    session: {
      expiredTitle: "आपका सत्र समाप्त हो गया",
      expiredBody: "आपकी सुरक्षा के लिए आपको लॉग आउट किया गया। जहाँ छोड़ा था वहीं से जारी रखने के लिए फिर से लॉग इन करें।",
      loginAgain: "फिर से लॉग इन करें",
      dismiss: "बंद करें",
    },
    nav: {
      home: "होम",
      useCases: "यूज़ केस",
      trust: "विश्वास",
      features: "फीचर्स",
      howItWorks: "कैसे काम करता है",
      pricing: "मूल्य निर्धारण",
      howToSetUp: "सेटअप",
      seeItInAction: "एक्शन",
      faq: "FAQ",
      corporate: "कॉर्पोरेट",
      login: "लॉगिन",
      getStarted: "शुरू करें",
      seeDemo: "डेमो देखें",
      reportEmergency: "आपातकाल रिपोर्ट करें",
      order: "ऑर्डर",
      scanLogin: "QR स्कैन करें",
      signUp: "साइन अप",
      profile: "प्रोफाइल",
      logout: "लॉग आउट",
      myOrders: "मेरे ऑर्डर",
      account: "खाता",
      signedInAs: "लॉग इन हैं",
    },
    hero: {
      badge: "भारत की सड़क सुरक्षा पहल",
      trustedBadge: "भारत भर में परिवारों द्वारा विश्वसनीय",
      headline: "आपातकाल में अगर आप बोल नहीं सकते, यह QR बोल सकता है।",
      subtitleCalm: "अपने परिवार को मन की शांति दें। आपातकाल में कोई भी आपका ब्लड ग्रुप, एलर्जी, दवाएं और किसे फोन करना है — तुरंत देख सकता है। ऐप की जरूरत नहीं।",
      subtitleNote: "केवल वही जानकारी जो मालिक साझा करना चाहे।",
      title: "स्कैन करें। रिपोर्ट करें। जीवन बचाएं।",
      titleAlt: "आपातकाल में, यह QR कोड आपकी ओर से बोलता है",
      subtitle:
        "किसी भी वाहन स्टिकर को जीवन रक्षक आपातकालीन प्रणाली में बदलें। एक QR स्कैन से राहगीर आपकी चिकित्सा जानकारी, आपातकालीन संपर्क और 112 सेवाओं से तुरंत जुड़ जाते हैं।",
      subtitleAlt:
        "अपने फोन, हेलमेट या पर्स पर एक छोटा QR कोड स्टिकर लगाएं। अगर आपको कुछ होता है, तो कोई भी स्कैन करके आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क तुरंत देख सकता है। ऐप की जरूरत नहीं।",
      cta: "अपना QR स्टिकर प्राप्त करें",
      scanCta: "मेरे पास पहले से QR कोड है",
      getQRCta: "मेरा QR कोड लें",
      ctaSecondary: "देखें कैसे काम करता है",
      check1: "बिना ऐप के काम करता है",
      check2: "सेकंडों में लोड होता है",
      check3: "एक बार खरीदें, जीवन भर इस्तेमाल करें",
    },
    trust: {
      label: "परिवारों द्वारा विश्वसनीय",
      title: "परिवार हम पर क्यों भरोसा करते हैं",
      subtitle: "आपकी चिकित्सा जानकारी उतनी ही देखभाल की हकदार है जितनी आप अपने परिवार को देते हैं।",
      t1: "एन्क्रिप्टेड और सुरक्षित",
      t1desc: "AES-256 एन्क्रिप्शन आपके डेटा की सुरक्षा करता है।",
      t2: "गोपनीयता पहले",
      t2desc: "DPDPA 2023 अनुपालन। आप नियंत्रित करते हैं क्या सार्वजनिक है।",
      t3: "आपातकाल के लिए बना",
      t3desc: "हर पल मायने रखता है — महत्वपूर्ण जानकारी सेकंडों में लोड होती है।",
      t4: "बिना ऐप के काम करता है",
      t4desc: "कोई भी स्मार्टफोन कैमरा आपकी प्रोफाइल तुरंत पढ़ सकता है।",
    },
    demo: {
      title: "इसे काम करते देखें",
      subtitle: "देखें EmergencyQR वास्तविक आपातकाल में कैसे मदद करता है।",
      imageAlt: "EmergencyQR उपयोग के मामले: सड़क दुर्घटना, बुजुर्ग माता-पिता, खोए बच्चे और पुरानी बीमारियां",
      cta: "सेटअप गाइड देखें",
    },
    howItWorks: {
      titleShort: "कैसे सेट अप करें",
      setupBadge: "सेटअप 2 मिनट से कम",
      step1TitleAlt: "अपना QR कोड ऑर्डर करें",
      step1DescAlt: "हम आपके दरवाजे पर वाटरप्रूफ QR स्टिकर डिलीवर करते हैं",
      step2TitleAlt: "अपनी जानकारी जोड़ें",
      step2DescAlt: "ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क भरें — 2 मिनट लगते हैं",
      step3TitleAlt: "आप सुरक्षित हैं",
      step3DescAlt: "अगर आपातकाल होता है, जो कोई भी QR कोड स्कैन करता है वह तुरंत आपकी जान बचाने वाली जानकारी देखता है",
      viewDemo: "लाइव डेमो देखें",
      knowMore: "और जानें",
    },
    useCases: {
      title: "आपको वाकई इसकी कब ज़रूरत पड़ेगी?",
      subtitle: "वास्तविक स्थितियाँ जहाँ एक साधारण QR कोड जान बचा सकता है — शायद आपकी",
      uc1Title: "सड़क दुर्घटनाएँ",
      uc1Desc:
        "बाइक या कार दुर्घटना के बाद आप बेहोश हैं। पैरामेडिक आपका QR कोड स्कैन करता है और तुरंत जानता है कि आपका ब्लड ग्रुप B+ है, आपको पेनिसिलिन से एलर्जी है, और आपकी पत्नी का नंबर। यही फर्क पड़ता है।",
      uc1Stat: "भारत में हर साल 1.5 लाख से अधिक सड़क मौतें",
      uc2Title: "अकेले रहने वाले बुजुर्ग माता-पिता",
      uc2Desc:
        "आपके पिता रोज़ 4 दवाएं लेते हैं और दूसरे शहर में रहते हैं। अगर वे बाज़ार में गिर जाएं, तो उनके फोन पर QR स्टिकर किसी को भी बता देगा कि किसे फोन करना है और उनकी कौन सी दवाएं चल रही हैं।",
      uc2Stat: "भारत में 10 करोड़ से अधिक वरिष्ठ नागरिक",
      uc3Title: "आपका बच्चा खो जाता है",
      uc3Desc:
        "भीड़ भरे मेले या मॉल में आपका बच्चा भटक जाता है। एक अजनबी उन्हें ढूंढता है, उनके बैग या कंगन पर QR कोड स्कैन करता है और सेकंडों में आपको फोन करता है। पुलिस स्टेशन या लाउडस्पीकर की जरूरत नहीं।",
      uc3Stat: "एक माता-पिता का सबसे बड़ा डर, सरलता से हल",
      uc4Title: "मधुमेह, हृदय रोग और एलर्जी",
      uc4Desc:
        "आप मधुमेह के मरीज़ हैं और ऑफिस में बेहोश हो जाते हैं। इस QR कोड के बिना, साथी आपको चीनी का पानी दे सकते हैं जबकि आपको इंसुलिन चाहिए। इसके साथ, उन्हें पता चल जाता है कि क्या गलत है और किसे बुलाना है।",
      uc4Stat: "भारत में अकेले 7.7 करोड़ से अधिक मधुमेह रोगी",
      protectCta: "खुद को बचाएं",
      knowMore: "और जानें",
      uc1Detail:
        "भारत में हर साल 1.5 लाख से अधिक लोग सड़क दुर्घटनाओं में जान गंवाते हैं। ज्यादातर मामलों में पीड़ित बेहोश होता है और महत्वपूर्ण चिकित्सा जानकारी नहीं बता पाता। आपके वाहन या हेलमेट पर EmergencyQR स्टिकर किसी भी राहगीर को तुरंत आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क देखने देता है।",
      uc2Detail:
        "भारत में 10 करोड़ से अधिक वरिष्ठ नागरिक अकेले रहते हैं। कई रोज़ कई दवाएं लेते हैं। उनके पास QR कोड स्टिकर होने से, अगर वे बाज़ार या पार्क में गिर जाएं, तो कोई भी स्कैन करके जान सकता है कि किसे फोन करना है और कौन सी दवाएं चल रही हैं।",
      uc3Detail:
        "भीड़ में बच्चे का खो जाना हर माता-पिता का डर है। बच्चे के बैग या कंगन पर EmergencyQR स्टिकर लगाने से, कोई भी अच्छा इंसान QR कोड स्कैन करके सेकंडों में आपको फोन कर सकता है।",
      uc4Detail:
        "भारत में 7.7 करोड़ लोगों को मधुमेह है, और लाखों हृदय रोग, गंभीर एलर्जी या मिर्गी से जूझ रहे हैं। आपातकाल में गलत प्राथमिक चिकित्सा जानलेवा हो सकती है। EmergencyQR स्टिकर सुनिश्चित करता है कि आपकी मदद करने वाला जानता है कि क्या गलत है और क्या नहीं करना है।",
    },
    features: {
      sectionTitle: "फीचर्स",
      sectionSubtitle: "जब कुछ गलत हो जाता है, तो सही समय पर सही जानकारी जान बचा सकती है।",
      f1Title: "स्कैन करें और देखें — बस",
      f1Desc:
        "कोई राहगीर या पैरामेडिक अपने फोन कैमरे को आपके QR कोड पर करता है। आपका ब्लड ग्रुप, एलर्जी, दवाएं और आपातकालीन संपर्क तुरंत उनकी स्क्रीन पर दिख जाते हैं। कोई ऐप डाउनलोड नहीं, साइनअप नहीं, समय बर्बाद नहीं।",
      f2Title: "सभी चिकित्सा विवरण एक जगह",
      f2Desc:
        "ब्लड ग्रुप, दैनिक दवाएं, दवा एलर्जी, पुरानी बीमारियां, डॉक्टर का नंबर — अस्पताल को आपका सही इलाज करने के लिए जो कुछ चाहिए, सब एक सुरक्षित प्रोफाइल में जो आप नियंत्रित करते हैं।",
      f3Title: "24/7 काम करता है, तब भी जब आप नहीं कर सकते",
      f3Desc:
        "आपातकाल समय नहीं देखता। रात 3 बजे हो या छुट्टी के दिन, आपका QR कोड हमेशा तैयार रहता है। जब तक स्कैन करने वाले के पास फोन और इंटरनेट है, आपकी जानकारी उपलब्ध है।",
      f4Title: "आप तय करते हैं क्या दिखे",
      f4Desc:
        "सब कुछ सार्वजनिक साझा करने में सहज नहीं? कोई बात नहीं। आप तय करते हैं कि स्कैन करने वाले को कौन सी जानकारी दिखे और कौन सी आपके पासवर्ड के पीछे निजी रहे। आपका डेटा एन्क्रिप्टेड है और आपकी अनुमति के बिना कभी साझा नहीं किया जाता।",
      f5Title: "हर परिवार के सदस्य के लिए एक",
      f5Desc:
        "अपने माता-पिता, बच्चों या जिसकी भी आप चिंता करते हैं उनके लिए QR कोड लें। हर व्यक्ति को अपनी चिकित्सा जानकारी के साथ अपना प्रोफाइल मिलता है। यह आपके प्रियजनों की देखभाल का सबसे आसान तरीका है।",
      f6Title: "जीरो ऐप। जीरो झंझट।",
      f6Desc:
        "आपकी मदद करने वाले को कुछ डाउनलोड करने की जरूरत नहीं। हर आधुनिक स्मार्टफोन अपने कैमरे से QR कोड स्कैन कर सकता है। एक स्कैन से आपकी जानकारी वाला एक साधारण पेज खुलता है — इतना आसान।",
      f1DetailDesc:
        "एक स्कैन से आपका ब्लड ग्रुप, एलर्जी, दवाइयाँ और इमरजेंसी कॉन्टैक्ट्स दिखते हैं — कोई ऐप डाउनलोड नहीं चाहिए। किसी भी स्मार्टफोन ब्राउज़र पर तुरंत काम करता है।",
      f1Cta: "हर सेकंड मायने रखता है। जीवन बचाने वाली जानकारी तुरंत पाएं।",
      f2DetailDesc:
        "ब्लड ग्रुप, एलर्जी, वर्तमान दवाइयाँ, पुरानी बीमारियाँ और सर्जिकल हिस्ट्री स्टोर करें। पैरामेडिक्स को तुरंत सबसे ज़रूरी जानकारी मिलती है।",
      f2Cta: "आपकी मेडिकल हिस्ट्री आपकी जान बचा सकती है। इसे सुरक्षित रूप से स्टोर करें।",
      f3DetailDesc:
        "आपका QR स्टिकर 24/7, 365 दिन काम करता है — बारिश हो या धूप। कोई बैटरी नहीं, कोई चार्जिंग नहीं, स्टिकर पर इंटरनेट की ज़रूरत नहीं।",
      f3Cta: "जब आपको सबसे ज़्यादा ज़रूरत हो, हमेशा तैयार।",
      f4DetailDesc:
        "आप तय करते हैं कि दूसरों को कौन सी जानकारी दिखे। हर फील्ड की विज़िबिलिटी टॉगल करें। आपका डेटा एन्क्रिप्टेड और सुरक्षित है।",
      f4Cta: "आपका डेटा, आपके नियम। पूरा प्राइवेसी कंट्रोल।",
      f5DetailDesc:
        "एक फैमिली अकाउंट में कई QR कोड लिंक करें। बुज़ुर्ग माता-पिता, बच्चों और परिवार के सदस्यों की निगरानी करें — एक ही डैशबोर्ड से।",
      f5Cta: "एक अकाउंट से पूरे परिवार की सुरक्षा करें।",
      f6DetailDesc:
        "कोई ऐप डाउनलोड नहीं, स्कैनर को अकाउंट नहीं चाहिए। फोन कैमरे वाला कोई भी व्यक्ति स्कैन करके तुरंत इमरजेंसी जानकारी देख सकता है।",
      f6Cta: "संकट में कोई भी इस्तेमाल कर सके, इतना आसान।",
      buyNow: "अभी खरीदें",
      getYoursCta: "अपना लें",
    },
    landing: {
      activeTitle: "आपातकालीन QR सक्रिय",
      viewInfo: "जानकारी देखें",
      ownerLogin: "मालिक लॉगिन",
      editInfo: "जानकारी संपादित करें",
      matchHolder: "QR कोड धारक से मिलान करें",
      matchHolderHint: "आपातकालीन जानकारी साझा करने से पहले सुनिश्चित करें कि व्यक्ति इस फ़ोटो से मेल खाता है",
    },
    login: {
      title: "लॉग इन",
      password: "पासवर्ड",
      passwordRequired: "पासवर्ड आवश्यक है",
      forgotPassword: "पासवर्ड भूल गए?",
      loggingIn: "लॉग इन हो रहा है...",
      alreadyLoggedIn: "आप पहले से लॉग इन हैं",
      locked: "बहुत अधिक असफल प्रयास। {{time}} में फिर कोशिश करें।",
    },
    forgotPassword: {
      title: "पासवर्ड भूल गए?",
      emailTab: "ईमेल",
      phoneTab: "मोबाइल OTP",
    },
    premium: {
      lockedTitle: "प्रीमियम फीचर लॉक",
      lockedDesc: "आपकी प्रीमियम सदस्यता समाप्त हो गई है। इस सेक्शन को अनलॉक करने के लिए नवीनीकरण करें।",
      upgradeCta: "प्रीमियम नवीनीकरण",
      buyCta: "प्रीमियम अपग्रेड — ₹199/वर्ष",
      upgradeTitle: "प्रीमियम फीचर्स अनलॉक करें",
      upgradeDesc: "असीमित फ़ील्ड, मेडिकल प्रोफ़ाइल, 20 MB दस्तावेज़ वॉल्ट और इमरजेंसी कार्ड। और प्रीमियम सुविधाएँ जल्द आ रही हैं।",
      medicalLockedTitle: "संरचित मेडिकल प्रोफ़ाइल",
      medicalLockedDesc: "आपका सहेजा मेडिकल डेटा प्रीमियम नवीनीकरण तक छिपा रहेगा।",
      expiresOn: "प्रीमियम {{date}} तक",
      expiresLine: "प्रीमियम ({{days}} दिन शेष) {{date}} तक",
      daysLeft: "{{days}} दिन शेष",
      renewMembership: "सदस्यता रिन्यू करें",
      sectionPremiumOnly: "यह सेक्शन प्रीमियम फीचर है।",
      popupTitle: "प्रीमियम सुविधाएँ",
      popupIntro: "हर स्टिकर के साथ पहले साल शामिल हैं, और प्रीमियम रिन्यूअल पर फिर से मिलती हैं।",
      popupClose: "बंद करें",
      popup: {
        f1: "असीमित आपातकालीन जानकारी फ़ील्ड",
        f2: "मेडिकल विवरण — एलर्जी, दवाइयाँ और गार्जियन संपर्क",
        f3: "प्रिस्क्रिप्शन और रिपोर्ट के लिए दस्तावेज़ वॉल्ट",
        f4: "डाउनलोड करने योग्य इमरजेंसी आईडी कार्ड",
        f5: "कोई आपका QR स्कैन करे तो स्कैन नोटिफिकेशन",
        f6: "आपातकालीन जानकारी की ऑफलाइन कॉपी",
        f7: "प्राथमिकता सहायता",
      },
      teaserScanAlerts: "प्रीमियम: आपातकाल में QR स्कैन पर तुरंत ईमेल और पुश अलर्ट",
      teaserMedicalProfile: "प्रीमियम: एलर्जी, दवाएं और गार्जियन संपर्क",
      teaserDocuments: "प्रीमियम: प्रिस्क्रिप्शन और रिपोर्ट के लिए सुरक्षित दस्तावेज़ वॉल्ट",
      teaserBloodSos: "प्रीमियम: आपातकाल में पास के रक्तदाताओं को Blood SOS",
      teaserUnlimitedFields: "प्रीमियम: असीमित आपातकालीन फ़ील्ड और सेक्शन",
      teaserExportCard: "प्रीमियम: QR के साथ बैज साइज आपातकालीन कार्ड एक्सपोर्ट",
    },
    emergencyInfo: {
      title: "आपातकालीन जानकारी",
      previewPublic: "पब्लिक व्यू देखें",
      dragReorder: "क्रम बदलने के लिए खींचें। दृश्यता टॉगल करें।",
      noItemsYet: '"फ़ील्ड जोड़ें" पर क्लिक करके जानकारी जोड़ें।',
      addField: "फ़ील्ड जोड़ें",
    },
    scanner: {
      scanTab: "स्कैन",
      loginTab: "लॉगिन",
      qrIdOrPhone: "QR कोड ID या मोबाइल नंबर",
      scanTitle: "QR कोड स्कैन करें या दर्ज करें",
    },
    profile: {
      title: "मेरी प्रोफाइल",
      linkedQR: "लिंक किए गए QR कोड",
      orderHistory: "ऑर्डर इतिहास",
      noOrders: "अभी तक कोई ऑर्डर नहीं",
      noQR: "अभी तक कोई QR कोड लिंक नहीं",
      familyDashboardTitle: "फैमिली डैशबोर्ड",
      familyDashboardDesc:
        "सभी फैमिली QR स्टिकर प्रबंधित करें, किसने प्रोफाइल सेट की है ट्रैक करें, और एक जगह से सदस्य जोड़ें।",
      familyDashboardDescWithCount:
        "आपके फैमिली पैक में {{count}} QR स्टिकर हैं। सभी के सेटअप के लिए फैमिली डैशबोर्ड खोलें।",
      familyDashboardCta: "फैमिली डैशबोर्ड खोलें",
      familyMemberIndividualNote:
        "आपका QR एक फैमिली पैक का हिस्सा है। आप यहाँ अपनी प्रोफाइल प्रबंधित करते हैं; फैमिली खाता मालिक सभी स्टिकर फैमिली डैशबोर्ड से प्रबंधित करता है।",
    },
    pricing: {
      title: "मूल्य निर्धारण",
      oneTimeTab: "स्टिकर",
      premiumTab: "प्रीमियम रिन्यूअल",
      oneTimeDesc: "हर स्टिकर के साथ 1 साल का प्रीमियम शामिल।",
      premiumDesc: "प्रीमियम को एक और साल के लिए बढ़ाएं।",
      oneTimeLabel: "एक बार",
      inclTaxes: "कर सहित",
      orderCta: "अभी ऑर्डर करें",
      launchPrice: "लॉन्च कीमत",
      bestValue: "सर्वोत्तम मूल्य",
      perYear: "/वर्ष",
      plans: {
        individual: {
          name: "इंडिविजुअल",
          desc: "1 QR कोड ID के साथ 2 स्टिकर (1x1 इंच)",
          f1: "1 यूनिक QR कोड ID",
          f2: "2 वाटरप्रूफ स्टिकर",
          f3: "1 साल प्रीमियम फीचर्स मुफ्त",
          f4: "असीमित आपातकालीन जानकारी फील्ड",
          f5: "मुफ्त शिपिंग",
        },
        family: {
          name: "फैमिली पैक",
          desc: "4 QR कोड IDs के साथ 8 स्टिकर (1x1 इंच)",
          f1: "4 यूनिक QR कोड IDs",
          f2: "8 वाटरप्रूफ स्टिकर (2 प्रति ID)",
          f3: "1 साल प्रीमियम फीचर्स मुफ्त",
          f4: "माता-पिता, बच्चों और खुद को सुरक्षित रखें",
          f5: "मुफ्त शिपिंग",
        },
        premium_yearly: {
          name: "प्रीमियम",
          desc: "आपके आपातकालीन QR कोड के लिए उन्नत फीचर्स",
          f1: "असीमित जानकारी फील्ड",
          f2: "स्कैन नोटिफिकेशन",
          f3: "दस्तावेज़ अपलोड",
          f4: "ऑफलाइन कैशिंग",
          f5: "प्राथमिकता सहायता",
        },
        family_yearly: {
          name: "फैमिली प्रीमियम",
          desc: "4 QR कोड IDs तक के लिए प्रीमियम फीचर्स",
          f1: "असीमित जानकारी फील्ड (4 QR IDs)",
          f2: "स्कैन नोटिफिकेशन",
          f3: "दस्तावेज़ अपलोड",
          f4: "ऑफलाइन कैशिंग",
          f5: "प्राथमिकता सहायता",
        },
      },
    },
    orderCheckout: {
      phoneSetupHint:
        "डिलीवरी अपडेट और यह ऑर्डर ट्रैक करने के लिए लॉग इन में उपयोग होगा। स्टिकर किसी भी फोन नंबर से सेट अप किया जा सकता है — इसी नंबर (और उसी पासवर्ड) से सेट अप करने पर यह ऑर्डर आपकी स्टिकर प्रोफाइल में दिखेगा।",
      giftOrderHint:
        "किसी और के लिए ऑर्डर कर रहे हैं? आपके नंबर पर पहले से QR है, इसलिए वे स्टिकर स्कैन करते समय अपने फोन नंबर से सेट अप करेंगे।",
      familyPackHint:
        "आपको 4 स्टिकर मिलेंगे। परिवार का हर सदस्य अपना स्टिकर अपने फोन नंबर से सेट अप करेगा, और हर स्टिकर को सेट अप के दिन से 12 महीने का प्रीमियम मिलेगा।",
      noPasswordNeeded: "अगले चरण में अपने अकाउंट के लिए पासवर्ड बनाएं। यह ऑर्डर ट्रैक करने के लिए मोबाइल नंबर और पासवर्ड से लॉग इन करें।",
      trackOrder: "अपना ऑर्डर ट्रैक करें",
      goToDashboard: "मेरे डैशबोर्ड पर जाएं",
      setupReminder:
        "जब स्टिकर आए, उसे स्कैन करके किसी भी फोन नंबर से सेट अप करें। यह ऑर्डर अपनी स्टिकर प्रोफाइल में देखने के लिए, ऑर्डर वाले नंबर और उसी पासवर्ड से सेट अप करें। ऑर्डर फोन नंबर से लॉग इन करके आप इसे कभी भी ट्रैक कर सकते हैं।",
      subscriptionAccountNote:
        "अपने मोबाइल नंबर या QR कोड ID और पासवर्ड से लॉग इन करें। प्रीमियम आपके अकाउंट के QR स्टिकर पर जोड़ा जाएगा।",
      subscriptionOwnerLabel: "अकाउंट",
      subscriptionPasswordLabel: "पासवर्ड",
      subscriptionPasswordPlaceholder: "आपका अकाउंट पासवर्ड",
      subscriptionPasswordHint: "वही पासवर्ड इस्तेमाल करें जो आपने इस QR स्टिकर को सेट अप करते समय बनाया था।",
      qrLinkContinueLogin: "अपने अकाउंट में लॉग इन करें",
      qrLinkContinuePayment: "भुगतान पर जाएं",
      paymentUnavailablePremium:
        "प्रीमियम के लिए ऑनलाइन भुगतान सेट अप हो रहा है। बाद में पुनः प्रयास करें या सहायता से संपर्क करें।",
      paymentUnavailablePhysical:
        "ऑनलाइन भुगतान सेट अप हो रहा है। अभी के लिए कैश ऑन डिलीवरी का उपयोग करें।",
      paymentTempUnavailablePremium:
        "ऑनलाइन भुगतान अस्थायी रूप से उपलब्ध नहीं है। बाद में पुनः प्रयास करें।",
      paymentTempUnavailablePhysical:
        "ऑनलाइन भुगतान अस्थायी रूप से उपलब्ध नहीं है। कैश ऑन डिलीवरी का उपयोग करें।",
      paymentGatewayFailedPremium:
        "भुगतान गेटवे लोड नहीं हो सका। कुछ मिनट बाद पुनः प्रयास करें।",
      paymentGatewayFailedPhysical:
        "भुगतान गेटवे लोड नहीं हो सका। पुनः प्रयास करें या कैश ऑन डिलीवरी चुनें।",
      paymentPremiumOnlineOnly: "प्रीमियम सदस्यता के लिए ऑनलाइन भुगतान (UPI या कार्ड) आवश्यक है।",
      orderIdLabel: "आपका ऑर्डर ID",
      notificationsSent:
        "हमने आपके ईमेल पर ऑर्डर ट्रैकिंग की जानकारी भेज दी है। नीचे अपना ऑर्डर ID सहेजें।",
      saveOrderId: "किसी भी समय ऑर्डर ट्रैक करने के लिए यह ID संभालकर रखें।",
      back: "वापस",
      continue: "आगे बढ़ें",
      continuePayment: "भुगतान पर जाएं",
      processing: "प्रोसेस हो रहा है…",
      placeOrder: "ऑर्डर करें",
      pay: "भुगतान करें",
      stepPlan: "अपना प्लान चुनें",
      stepShipping: "डिलीवरी का पता",
      stepAccount: "अपना अकाउंट बनाएं",
      accountExists: "मोबाइल नंबर {{phone}} पर पहले से अकाउंट है। आगे बढ़ने के लिए पासवर्ड डालें।",
      checkingAccount: "यह मोबाइल नंबर जाँचा जा रहा है…",
      stepQr: "अपना QR कोड जोड़ें",
      stepSignIn: "साइन इन करें",
      stepPayment: "भुगतान",
      stepConfirmed: "ऑर्डर की पुष्टि हो गई!",
      stepActivated: "सदस्यता सक्रिय हो गई!",
      progressPlan: "प्लान चुनें",
      progressShipping: "डिलीवरी",
      progressPayment: "भुगतान",
      progressQr: "QR जोड़ें",
      estimatePlan: "लगभग 2 मिनट",
      estimateShipping: "लगभग 60 सेकंड",
      estimatePayment: "लगभग पूरा",
      estimateQr: "लगभग 60 सेकंड",
      fullName: "पूरा नाम",
      nameLabel: "नाम",
      nameRequired: "नाम ज़रूरी है",
      phoneLabel: "फ़ोन",
      phonePlaceholder: "10 अंकों का नंबर",
      phoneRequired: "फ़ोन ज़रूरी है",
      phoneInvalid: "सही 10 अंकों का नंबर डालें",
      cityLabel: "शहर",
      cityRequired: "शहर ज़रूरी है",
      pinLabel: "पिन कोड",
      pinPlaceholder: "6 अंकों का पिन",
      pinRequired: "पिन ज़रूरी है",
      pinInvalid: "सही 6 अंकों का पिन डालें",
      addressLabel: "पता",
      addressPlaceholder: "मकान / फ्लैट, इमारत",
      addressRequired: "पता ज़रूरी है",
      areaLabel: "इलाका / कॉलोनी",
      areaPlaceholder: "इलाका या कॉलोनी",
      areaRequired: "इलाका ज़रूरी है",
      stateLabel: "राज्य",
      stateRequired: "राज्य ज़रूरी है",
      selectState: "राज्य चुनें",
      optionalDetails: "और जानकारी जोड़ें",
      landmarkLabel: "लैंडमार्क",
      optional: "वैकल्पिक",
      addressLine2: "पता पंक्ति 2",
      addressLine2Placeholder: "सड़क (वैकल्पिक)",
      stickersTab: "QR और स्टिकर",
      premiumTab: "प्रीमियम",
      stickersHint: "हर प्लान में 1 साल की प्रीमियम सुविधाएं मुफ़्त हैं।",
      premiumHint: "स्कैन नोटिफिकेशन, दस्तावेज़ अपलोड और अन्य सुविधाएं खोलें।",
      yourSelection: "आपका चयन",
      total: "कुल",
      freeShippingTitle: "पूरे भारत में मुफ़्त शिपिंग",
      freeShippingNote: "5–7 कार्य दिवसों में डिलीवरी",
      shipping: "शिपिंग",
      free: "मुफ़्त",
      deliverTo: "डिलीवरी पता",
      membershipFor: "सदस्यता",
      edit: "बदलें",
      choosePay: "भुगतान का तरीका चुनें",
      preferred: "सुझाया गया",
      notAvailable: "अभी उपलब्ध नहीं",
      agree: "मैं सहमत हूँ",
      terms: "नियम",
      and: "और",
      refund: "रिफंड नीति",
      securePay: "भुगतान सुरक्षित और एन्क्रिप्टेड है",
      cardLabel: "क्रेडिट / डेबिट कार्ड",
      cardSub: "Visa, Mastercard, Rupay, Amex",
      codLabel: "कैश ऑन डिलीवरी",
      codSub: "पैकेट मिलने पर भुगतान करें",
      upiSub: "Google Pay, PhonePe, Paytm, BHIM",
      testMode: "टेस्ट मोड — कार्ड 4111 1111 1111 1111 इस्तेमाल करें",
      quantity: "मात्रा",
      estimatedDelivery: "अनुमानित डिलीवरी",
      deliveryDays: "5–7 दिन",
      perYear: "/वर्ष",
    },
    orderPostPurchase: {
      confirmedTitle: "आपका ऑर्डर पुष्टि हो गया 🎉",
      confirmedSubtitle: "आपका Emergency QR स्टिकर तैयार किया जा रहा है।",
      estimatedDelivery: "अनुमानित डिलीवरी: 5–7 कार्य दिवस",
      estimatedDeliveryLabel: "अनुमानित डिलीवरी",
      delivered: "डिलीवर हो गया",
      nextSteps: "अगले चरण",
      copied: "क्लिपबोर्ड पर कॉपी हो गया",
      trackMyOrder: "मेरा ऑर्डर ट्रैक करें",
      viewSetupGuide: "सेटअप गाइड देखें",
      openSetupGuide: "सेटअप गाइड खोलें",
      whileYouWait: "❤️ इंतज़ार के दौरान…",
      whileYouWaitSub: "आपका स्टिकर 5–7 दिनों में आएगा। तब तक आप यह कर सकते हैं:",
      whileTip1: "सेटअप गाइड पढ़ें",
      whileTip2: "अपनी आपातकालीन जानकारी तैयार करें",
      whileTip3: "दवाओं की जानकारी इकट्ठा करें",
      whileTip4: "आपातकालीन संपर्क तैयार रखें",
      premiumTitle: "प्रीमियम सक्रिय! 🎉",
      premiumActive: "आपके QR कोड पर प्रीमियम सुविधाएं अब सक्रिय हैं।",
      currentStatus: "वर्तमान स्थिति",
      progress: "प्रगति",
      orderSummary: "ऑर्डर सारांश",
      premiumIncluded: "प्रीमियम शामिल",
      orderedOn: "ऑर्डर दिनांक",
      deliveringTo: "डिलीवरी पता",
      deliveryAddress: "पूरा डिलीवरी पता",
      phone: "फ़ोन",
      mobile: "मोबाइल",
      qrAssigned: "QR कोड असाइन हो गया",
      setupSticker: "अपना स्टिकर सेट अप करें",
      statusNotify: "ऑर्डर की स्थिति बदलने पर हम ईमेल से सूचित करेंगे।",
      backToOrder: "मेरे ऑर्डर पर वापस",
      helpTitle: "मदद चाहिए?",
      whatsapp: "WhatsApp",
      email: "ईमेल",
      setupGuide: "सेटअप गाइड",
      trackDetails: "विवरण देखें",
      loading: "ऑर्डर विवरण लोड हो रहा है…",
      notFound: "ऑर्डर नहीं मिला। कृपया ऑर्डर ID जांचें।",
      notFoundTitle: "ऑर्डर नहीं मिला",
      step_received: "ऑर्डर प्राप्त",
      step_payment: "भुगतान प्राप्त",
      step_printing: "प्रिंटिंग",
      step_packed: "पैक किया गया",
      step_shipped: "भेज दिया गया",
      step_delivered: "डिलीवर",
      step_activated: "सक्रिय",
    },
    benefits: {
      badge: "फायदे",
      title: "भरोसेमंद सुरक्षा।",
      subtitle: "सड़क पर खुद को और दूसरों की मदद करने के लिए जो कुछ चाहिए, वह सब।",
      b1Title: "तुरंत आपातकालीन पहुंच",
      b1Desc:
        "एक स्कैन से ब्लड ग्रुप, एलर्जी, आपातकालीन संपर्क और चिकित्सा स्थिति किसी भी राहगीर को दिखती है।",
      b2Title: "सीधा 112 एकीकरण",
      b2Desc:
        "ERSS (112), एम्बुलेंस (108) और पुलिस (100) कॉल करने के बटन, ऑटो-लोकेशन शेयरिंग के साथ।",
      b3Title: "मार्गदर्शित प्राथमिक चिकित्सा",
      b3Desc:
        "चरण-दर-चरण DRABC प्रोटोकॉल और CPR निर्देश गोल्डन आवर के दौरान राहगीरों को प्रभावी रखते हैं।",
      b4Title: "गुड समारिटन सुरक्षा",
      b4Desc:
        "भारत के गुड समारिटन नियम दुर्घटना में मदद करने वालों की रक्षा करते हैं। राज्य राह-वीर / PM-RAHAT योजनाओं में सरकारी मान्यता हो सकती है — MoRTH और राज्य परिवहन विभाग देखें।",
      b5Title: "फैमिली पैक",
      b5Desc:
        "माता-पिता, बच्चों और जीवनसाथी के लिए 4 स्टिकर। हर व्यक्ति अपने फोन नंबर से अपना स्टिकर सेट करता है।",
      b6Title: "DPDPA अनुपालन",
      b6Desc:
        "आपका चिकित्सा डेटा AES-256 से एन्क्रिप्टेड है और भारत के डिजिटल पर्सनल डेटा प्रोटेक्शन एक्ट के तहत सुरक्षित है।",
    },
    testimonials: {
      badge: "वास्तविक प्रभाव",
      title: "जान बचाने वाली कहानियाँ।",
      subtitle: "वास्तविक परिवार और फ्लीट प्रबंधक साझा करते हैं कि सेकंड मायने रखते हैं तब EmergencyQR ने कैसे मदद की।",
    },
    ctaSection: {
      title: "आज ही अपना QR कोड पाएं",
      subtitle: "एक बार खरीदें। जीवन भर इस्तेमाल। 2 मिनट में सेट अप।",
      orderButton: "ऑर्डर",
    },
    setup: {
      stickerForTitle: "यह स्टिकर किसके लिए है?",
      stickerForIntro: "चुनें कि यह स्टिकर कैसे इस्तेमाल होगा। बच्चे, पालतू और वाहन के स्टिकर मौजूदा अभिभावक/मालिक खाते से जुड़ते हैं — नया मोबाइल नंबर नहीं जोड़ा जाता।",
      adultTitle: "व्यक्ति (वयस्क)",
      adultDesc: "आपके या किसी अन्य वयस्क के लिए। उनका लॉगिन बनता है।",
      childTitle: "व्यक्ति (बच्चा)",
      childDesc: "नया मोबाइल नंबर नहीं। अभिभावक साइन-इन के बाद माता-पिता खाते से जुड़ता है।",
      petTitle: "पालतू जानवर",
      petDesc: "कुत्ता, बिल्ली या अन्य पालतू — मालिक के रूप में साइन इन करें।",
      vehicleTitle: "वाहन",
      vehicleDesc: "कार, बाइक या स्कूटर — मालिक के रूप में साइन इन करें।",
      title: "अपना QR सेट करें",
      takes2Min: "2 मिनट लगते हैं",
      continueCta: "आगे बढ़ें — आपातकालीन जानकारी जोड़ें",
      creatingAccount: "आपका खाता बनाया जा रहा है...",
      mobileLabel: "मोबाइल नंबर",
      emailLabel: "ईमेल",
      passwordLabel: "पासवर्ड",
      confirmPasswordLabel: "पासवर्ड दोबारा लिखें",
      nameLabel: "पूरा नाम",
      addressLabel: "घर का पता (वैकल्पिक)",
      languageLabel: "पसंदीदा भाषा",
      photoLabel: "स्टिकर मालिक की फोटो",
      backToChoices: "विकल्पों पर वापस जाएँ",
      preferNotShare: "साझा नहीं करना चाहते",
    },

    public: {
      medicalInfoTitle: "आपातकालीन जानकारी",
      quickActions: "त्वरित कार्रवाई",
      moreOptions: "अधिक विकल्प",
      reportEmergency: "आपातकाल रिपोर्ट करें",
      contactThisPerson: "इस व्यक्ति से संपर्क करें",
      ownerValidationNote: "नीचे दी गई आपातकालीन जानकारी पढ़ने से पहले सुनिश्चित करें कि यही वह व्यक्ति है।",
      owner: "मालिक",
      editInformation: "जानकारी संपादित करें",
      noDetailsTitle: "अभी तक कोई विवरण नहीं जोड़ा गया",
      noDetailsDesc:
        "इस QR कोड के मालिक ने अभी तक कोई आपातकालीन जानकारी नहीं जोड़ी। यदि आप मालिक हैं, तो अपनी जानकारी जोड़ने के लिए लॉग इन करें।",
      loadingDetails: "चिकित्सा जानकारी लोड हो रही है...",
      errorTitle: "कुछ गलत हो गया",
      footerTagline: "EmergencyQR.in | DPDPA 2023 | 112 India",
      reportDisclaimerIntro:
        "यह विकल्प केवल वास्तविक आपातकाल की स्थिति में चुनें, न कि मज़ाक या दुरुपयोग के लिए। गलत रिपोर्ट के कानूनी परिणाम हो सकते हैं।",
      reportDisclaimerLegal: "यह विकल्प केवल वास्तविक आपातकाल में चुनें। गलत रिपोर्ट के गंभीर परिणाम हो सकते हैं।",
      govRecognitionTitle: "सरकारी मान्यता और पुरस्कार",
      govRecognitionDesc: "वास्तविक रिपोर्ट से जान बच सकती है और सरकारी मान्यता व पुरस्कार के योग्य हो सकते हैं।",
      understandReport: "मैं समझ गया, रिपोर्ट करें",
      logout: "लॉगआउट",
      freeForeverBadge: "हमेशा मुफ्त — स्कैन के लिए ऐप नहीं चाहिए",
      activeMedications: "सक्रिय दवाइयां",
      scanConsentEyebrow: "आपातकालीन सहायता",
      scanConsentTitle: "किसी की जान बचाने में मदद करें",
      scanConsentSubtitle: "आप किसी आपातकाल में मदद करने वाले हैं।",
      scanConsentDescription:
        "आपातकालीन जानकारी दिखाने से पहले कृपया अपना स्थान साझा करें ताकि स्टिकर के मालिक को अलर्ट मिल सके।",
      scanConsentNote: "आपका स्थान केवल इस आपातकाल के लिए एक बार साझा होता है।",
      scanConsentTrust1: "केवल एक बार साझा",
      scanConsentTrust2: "स्थायी रूप से संग्रहीत नहीं",
      scanConsentTrust3: "पृष्ठभूमि में कभी ट्रैक नहीं",
      scanConsentHumanNote: "केवल तभी आगे बढ़ें जब आप किसी आपातकाल में मदद कर रहे हों।",
      scanConsentBody:
        "केवल वास्तविक आपातकाल में आगे बढ़ें। आपका स्थान एक बार स्टिकर मालिक के साथ साझा होगा। हम लगातार ट्रैक नहीं करते।",
      scanConsentConfirm: "मेरा स्थान साझा करें",
      scanConsentSecondary: "बिना स्थान के आगे बढ़ें",
      scanConsentLoading: "आपका स्थान साझा हो रहा है...",
      scanConsentSuccessTitle: "स्थान साझा हो गया",
      scanConsentSuccessBody: "स्टिकर मालिक को सूचित किया जा रहा है।",
      scanConsentSuccessNext: "आपातकालीन प्रोफ़ाइल खोली जा रही है...",
      scanConsentPrivacyLink: "हमें आपका स्थान क्यों चाहिए?",
      scanConsentPrivacyTitle: "हम स्थान क्यों मांगते हैं",
      scanConsentPrivacyBody:
        "जब आप EmergencyQR स्टिकर स्कैन करते हैं, मालिक को अलर्ट मिल सकता है कि मदद की ज़रूरत हो सकती है। हम आपका स्थान केवल एक बार — इसी क्षण — इस्तेमाल करते हैं। प्रोफ़ाइल से कॉल करने पर आपातकालीन संपर्कों को अलग से सूचित किया जाता है। EmergencyQR बाद में आपको ट्रैक नहीं करता।",
      scanConsentCall108: "एम्बुलेंस कॉल करनी है?",
      scanConsentCall108Link: "108 पर कॉल करें",
      essentialCardBadge: "आपातकालीन जरूरी जानकारी",
      essentialCardSubtitle: "पहले प्रतिक्रिया देने वालों के लिए",
      notProvided: "दर्ज नहीं",
      essentialIncompleteHint: "मालिक ने सभी जरूरी फ़ील्ड नहीं भरी। नीचे हेल्पलाइन उपयोग करें।",
      callPrimary: "आपातकालीन संपर्क को कॉल करें",
      directCallNote: "सीधी कॉल — कॉल मास्किंग प्रीमियम सुविधा है (जल्द आ रही है)।",
      noPrimaryContact: "कोई आपातकालीन संपर्क नहीं। नीचे राष्ट्रीय हेल्पलाइन उपयोग करें।",
      otherContacts: "अन्य आपातकालीन संपर्क",
      helplineTitle: "भारत आपातकालीन नंबर",
      helplineSubtitle: "कॉल के लिए टैप करें",
      helpline112: "राष्ट्रीय ERSS",
      helpline108: "एम्बुलेंस",
      helpline1098: "चाइल्डलाइन",
      helpline181: "महिला हेल्पलाइन",
      helpline1098Desc: "1098 — बच्चा संकट में",
      helpline181Desc: "181 — महिला सहायता",
      helplineFootnote: "दुर्घटना: 112 · एम्बुलेंस: 108 · बच्चे: 1098 · महिला: 181",
      reportEmergencySub: "स्थान और वैकल्पिक वीडियो साझा करें",
      guidedRescue: "मार्गदर्शित बचाव (DRABC)",
      guidedRescueSub: "राहगीरों के लिए प्राथमिक चिकित्सा",
      nearbyServices: "नजदीकी अस्पताल और ब्लड बैंक",
      nearbyServicesSub: "पास में मदद खोजें",
      findMyReport: "मेरी आपातकालीन रिपोर्ट खोजें",
      findMyReportSub: "राहगीर के रूप में रिकॉर्ड किया वीडियो देखें",
      resumeReportBanner: "इस डिवाइस पर हाल की रिपोर्ट है — जारी रखने के लिए टैप करें",
      additionalInfo: "अतिरिक्त जानकारी",
      tabEssentials: "ज़रूरी जानकारी",
      tabActions: "कार्रवाई",
      tabMedical: "चिकित्सा",
      tabDetails: "अधिक जानकारी",
      premiumSectionLocked: "प्रीमियम सामग्री लॉक",
      premiumSectionLockedDesc: "यह जानकारी देखने के लिए प्रीमियम नवीनीकरण करें।",
      premiumFieldLocked: "प्रीमियम — अनलॉक के लिए नवीनीकरण",
      callConfirmTitle: "आपातकालीन संपर्क को कॉल करें?",
      callNow: "अभी कॉल करें",
      callConfirmBody: "{{owner}} के लिए {{name}} को कॉल। केवल वास्तविक आपातकाल में।",
      callRevealTitle: "आपातकालीन कॉल",
      callRevealLocationIntro:
        "जब फोन पूछे तो लोकेशन चालू करें। अपना स्थान साझा करने से आपातकालीन संपर्क तेज़ी से पहुंच सकते हैं। अत्यधिक अनुशंसित।",
      callRevealLocationPrompt:
        "नीचे टैप करें। फोन पर लोकेशन की अनुमति का मेनू दिखेगा—यदि संभव हो Allow या While using the app चुनें।",
      callRevealLocationWaiting: "इस फोन पर आपके स्थान विकल्प की प्रतीक्षा…",
      callRevealLocationDenied: "स्थान साझा नहीं हुआ। आप फिर भी कॉल कर सकते हैं।",
      callRevealLocationTimeout: "स्थान समय समाप्त। आप फिर भी कॉल कर सकते हैं।",
      callRevealContinue: "आगे बढ़ें",
      callRevealShareLocation: "मेरा स्थान साझा करें",
      callRevealSkipLocation: "बिना स्थान के कॉल करें",
      callRevealBody:
        "आप आपातकालीन कॉल शुरू कर रहे हैं। सुरक्षा के लिए स्थान और डिवाइस विवरण लॉग किए जाते हैं।",
      callRevealContact: "{{name}} को कॉल",
      callRevealWorking: "कॉल कनेक्ट हो रही है…",
      callRevealDialNow: "अभी {{name}} को कॉल करें",
      callRevealDialHint: "फोन डायलर खोलने के लिए नीचे बटन टैप करें। स्थान आपातकालीन संपर्कों के साथ साझा हो चुका है।",
      bystanderMedicalHeading: "मददगार के लिए ज़रूरी",
      callRevealModeTitle: "आपातकालीन कॉल गोपनीयता",
      callRevealModeExpress: "एक्सप्रेस आपातकाल (अनुशंसित)",
      callRevealModeExpressDesc: "एक टैप पुष्टि, फिर डायलर में संपर्क का नंबर। आपको और आपातकालीन संपर्क को अलर्ट मिलता है।",
      callRevealModeVerified: "सत्यापित राहगीर (जल्द)",
      callRevealModeVerifiedDesc: "नंबर दिखाने से पहले राहगीर मोबाइल सत्यापित करेगा।",
      goodSamaritanTitle: "गुड समारिटन सुरक्षा",
      goodSamaritanSubtitle: "दुर्घटना पीड़ित की मदद पर कानूनी प्रतिरक्षा",
      goodSamaritanPoint1: "मदद करने पर गवाही के लिए मजबूर नहीं किया जा सकता।",
      goodSamaritanPoint2: "अस्पताल इलाज से इनकार नहीं कर सकते।",
      goodSamaritanPoint3: "रिपोर्ट + मार्गदर्शित बचाव से पुरस्कार का दावा करें।",
      goodSamaritanPoint3Paused:
        "आपातकाल रिपोर्ट और मार्गदर्शित प्राथमिक चिकित्सा से पेशेवर मदद आने तक सुरक्षित रूप से सहायता करें।",
      rahVeerInfoTitle: "सरकारी राह-वीर / गुड समारिटन मान्यता",
      rahVeerInfoBody:
        "भारत सरकार सड़क दुर्भागना में मदद करने वाले राहगीरों को प्रोत्साहित करती है। गुड समारिटन दिशानिर्देशों और राज्य राह-वीर या PM-RAHAT योजनाओं के तहत, आधिकारिक प्रक्रिया पर मदद करने वालों को मान्यता (अक्सर ₹25,000 तक) और कानूनी सुरक्षा मिल सकती है। आवेदन राज्य परिवहन विभाग या 112 ERSS पोर्टल से करें — ऐप में अभी पुरस्कार दावा उपलब्ध नहीं है।",
      rahVeerTitle: "राह-वीर / PM-RAHAT पुरस्कार (₹25,000 तक)",
      rahVeerHowTo: "सड़क दुर्भागना में मदद के बाद पुरस्कार का दावा:",
      rahVeerStep1: "112 पर कॉल करें, PM-RAHAT अस्पताल में पहुंचाएं।",
      rahVeerStep2: "आपातकाल रिपोर्ट + वीडियो पूरा करें।",
      rahVeerStep3: "DRABC मार्गदर्शित बचाव पूरा करें।",
      rahVeerStep4: "राज्य परिवहन / 112 पोर्टल पर रिपोर्ट ID से आवेदन करें।",
      startGuidedRescue: "मार्गदर्शित बचाव शुरू करें",
      goodSamaritanLink: "MoRTH गुड समारिटन दिशानिर्देश",
      lookupTitle: "आपातकालीन रिपोर्ट खोजें",
      lookupSubtitle: "राहगीरों के लिए",
      lookupIntro:
        "वीडियो देखने और मार्गदर्शित बचाव जारी रखने के लिए OTP से मोबाइल नंबर सत्यापित करें। बाद में वापस आने पर OTP आवश्यक है।",
      lookupPhone: "आपका मोबाइल नंबर",
      lookupPhonePlaceholder: "10 अंकों का मोबाइल",
      lookupPhoneHint: "रिपोर्ट करते समय दर्ज किया गया वही नंबर उपयोग करें।",
      lookupPhoneInvalid: "मान्य 10 अंकों का भारतीय मोबाइल दर्ज करें।",
      lookupSendOtp: "OTP भेजें",
      lookupOtp: "OTP दर्ज करें",
      lookupOtpSent: "OTP भेजा गया",
      lookupVerifyOtp: "OTP सत्यापित करें",
      lookupChangePhone: "नंबर बदलें",
      lookupOtpInvalid: "6 अंकों का सत्यापन कोड दर्ज करें।",
      lookupOtpSendFailed: "OTP नहीं भेजा जा सका। कुछ मिनट बाद पुनः प्रयास करें।",
      lookupOtpVerifyFailed: "अमान्य या समाप्त OTP।",
      lookupSmsUnavailable:
        "सत्यापन कोड अभी उपलब्ध नहीं हैं। रिपोर्ट देखने के लिए support@emergencyqr.in पर ईमेल करें।",
      lookupYourReports: "इस QR की आपकी रिपोर्ट",
      lookupHasVideo: "वीडियो है",
      lookupNoReports: "इस नंबर की कोई रिपोर्ट नहीं मिली।",
      lookupBackToList: "सूची पर वापस",
      lookupLoadingVideo: "वीडियो लोड हो रहा है…",
      lookupReportId: "रिपोर्ट ID",
      lookupFailed: "रिपोर्ट लोड नहीं हुई।",
      lookupLoading: "लोड हो रहा है…",
      lookupFound: "रिपोर्ट मिली",
      lookupLocation: "स्थान",
      lookupVideo: "रिकॉर्ड किया साक्ष्य",
      lookupNoVideo: "इस रिपोर्ट में वीडियो नहीं है।",
      continueRescue: "बचाव जारी रखें",
      backToProfile: "इमरजेंसी कार्ड पर वापस",
      lookupView: "देखें",
      emergencySnapshot: "आपातकालीन सारांश",
      infoVerified: "जानकारी सत्यापित",
      lastUpdated: "अंतिम अपडेट",
      notAvailable: "उपलब्ध नहीं",
      shareLocation: "स्थान साझा करें",
      shareLocationSub: "अपना GPS पिन भेजें",
      reportEmergencySubShort: "अलर्ट और साक्ष्य रिकॉर्ड करें",
      guidedRescueSubShort: "चरण-दर-चरण प्राथमिक चिकित्सा",
      nearbyServicesSubShort: "अस्पताल और ब्लड बैंक",
      findMyReportSubShort: "सहेजा वीडियो देखें",
      uploadEvidence: "साक्ष्य अपलोड करें",
      callPrimaryContact: "प्राथमिक संपर्क को कॉल करें",
      bloodGroupLabel: "रक्त समूह",
      allergiesLabel: "एलर्जी",
      conditionsLabel: "चिकित्सा स्थितियां",
      primaryContactLabel: "प्राथमिक आपातकालीन संपर्क",
      emergencyContacts: "आपातकालीन संपर्क",
      medicalInformation: "चिकित्सा जानकारी",
      personalInformation: "व्यक्तिगत जानकारी",
      emergencyDetails: "आपातकालीन विवरण",
      otherInformation: "अन्य जानकारी",
      fieldName: "नाम",
      fieldAge: "उम्र",
      fieldGender: "लिंग",
      fieldAddress: "पता",
      fieldLanguage: "पसंदीदा भाषा",
      fieldInsurance: "बीमा",
      fieldDoctor: "डॉक्टर",
      fieldHospital: "पसंदीदा अस्पताल",
      fieldGenderMale: "पुरुष",
      fieldGenderFemale: "महिला",
      ageYears: "वर्ष",
      noPhoto: "फोटो नहीं",
      tapToEnlarge: "बड़ा देखने के लिए फोटो टैप करें",
      verifyPhotoHint: "इस जानकारी का उपयोग करने से पहले फोटो को व्यक्ति से मिलाएं।",
      verifyPhotoHintPet: "इस जानकारी का उपयोग करने से पहले फोटो को पालतू जानवर से मिलाएं।",
      verifyPhotoHintVehicle: "इस जानकारी का उपयोग करने से पहले फोटो को वाहन से मिलाएं।",
      verifyNoPhotoHint: "फोटो नहीं जोड़ी गई। उपयोग से पहले नाम, उम्र और लिंग की पुष्टि करें।",
      verifyNoPhotoHintPet: "फोटो नहीं जोड़ी गई। उपयोग से पहले पालतू का नाम और विवरण पुष्टि करें।",
      verifyNoPhotoHintVehicle: "फोटो नहीं जोड़ी गई। उपयोग से पहले वाहन का विवरण पुष्टि करें।",
      closePhoto: "फोटो बंद करें",
      ownerPhotoAlt: "{{name}} की फोटो",
      quickReport: "आपातकाल रिपोर्ट",
      quickFirstAid: "प्राथमिक चिकित्सा",
      quickNearby: "नज़दीकी अस्पताल",
      quickShare: "स्थान साझा करें",
      quickFindReport: "मेरी रिपोर्ट",
      sosEmergency: "आपातकाल",
      sosAmbulance: "एम्बुलेंस",
      sosPolice: "पुलिस",
      sosWomen: "महिला",
      sosBarLabel: "भारत आपातकाल नंबर",
      noPrimaryContactShort: "कोई संपर्क नहीं",
      footerDpdpa: "DPDPA 2023 अनुपालन · डेटा केवल आपातकालीन प्रतिक्रिया के लिए",
      footerEmergency: "जानलेवा आपातकाल में भारत में 112 या 108 पर कॉल करें",
    },
    emergency: {
      reportTitle: "आपातकाल रिपोर्ट करें",
      reportSubtitle: "आपातकाल की रिपोर्ट करें",
      step1: "स्थान की पुष्टि करें",
      step2: "आपातकाल का प्रकार",
      step3: "साक्ष्य रिकॉर्ड करें",
      step4: "आपका फोन नंबर",
      medical: "चिकित्सा",
      accident: "दुर्घटना",
      fire: "आग / अन्य",
      capturingLocation: "आपका स्थान प्राप्त कर रहे हैं...",
      locationCaptured: "स्थान सफलतापूर्वक प्राप्त हुआ",
      locationFailed: "स्थान प्राप्त नहीं हो सका। कृपया मैन्युअल रूप से दर्ज करें।",
      videoReward:
        "मुफ्त QR कोड, 3 महीने की सदस्यता और सरकारी राह-वीर पुरस्कार Rs.25,000 के लिए 10 सेकंड का वीडियो रिकॉर्ड करें",
      phoneRequired: "कॉलबैक और पुरस्कार दावे के लिए फोन नंबर आवश्यक",
      submitReport: "आपातकालीन रिपोर्ट जमा करें",
      needLocationDesc: "आपातकालीन सेवाओं को तुरंत भेजने के लिए हमें आपका स्थान चाहिए।",
      manualAddressLabel: "पता मैन्युअल रूप से दर्ज करें (वैकल्पिक)",
      manualAddressPlaceholder: "लैंडमार्क, सड़क का नाम या इलाका दर्ज करें...",
      nextSelectType: "अगला - आपातकाल प्रकार चुनें",
      tryAgain: "पुनः प्रयास करें",
      selectTypeDesc: "प्रकार चुनने पर नंबर डायल होगा। अभी कॉल करने के लिए टैप करें।",
      callInitiated: "कॉल शुरू हो गया",
      callInitiatedTo: "कॉल शुरू हो गया",
      continueNext: "अगले चरण पर जाएं →",
      recordEvidenceOptional: "साक्ष्य रिकॉर्ड करें (वैकल्पिक)",
      earnRewards: "पुरस्कार कमाएं!",
      startRecording: "रिकॉर्डिंग शुरू करें",
      stopRecording: "रिकॉर्डिंग रोकें",
      recordAgain: "फिर से रिकॉर्ड करें",
      videoRecorded: "वीडियो सफलतापूर्वक रिकॉर्ड हुआ!",
      tapToStartRecording: "10 सेकंड की रिकॉर्डिंग शुरू करने के लिए नीचे टैप करें",
      cameraDenied: "कैमरा एक्सेस अस्वीकृत या अनुपलब्ध।",
      skip: "छोड़ें",
      next: "अगला",
      yourPhoneNumber: "आपका फोन नंबर",
      phoneRequiredDesc: "कॉलबैक सत्यापन और पुरस्कार दावे के लिए आवश्यक।",
      phoneRequiredDescPaused: "जरूरत पड़ने पर आपातकालीन संपर्क आप तक पहुंच सकें, इसके लिए आवश्यक।",
      phoneLabel: "फोन नंबर",
      enterPhonePlaceholder: "10 अंकों का नंबर दर्ज करें",
      phonePrivacyNote: "आपका नंबर केवल आपातकालीन कॉलबैक और पुरस्कार सत्यापन के लिए उपयोग किया जाएगा।",
      phonePrivacyNotePaused: "आपका नंबर केवल इस रिपोर्ट से जुड़े आपातकालीन फॉलो-अप के लिए उपयोग होगा।",
      submitting: "जमा हो रहा है...",
      reportSubmitted: "रिपोर्ट जमा हो गई",
      redirecting: "प्राथमिक चिकित्सा मार्गदर्शन पर रीडायरेक्ट हो रहा है...",
      rahVeerEligible: "राह-वीर पुरस्कार के पात्र!",
      rewardAmount: "Rs.25,000 + कानूनी प्रतिरक्षा",
      emergency112: "112 आपातकाल",
      locationUnavailable: "स्थान अनुपलब्ध",
      submitError: "रिपोर्ट जमा करने में विफल। कृपया पुनः प्रयास करें।",
      phoneValidationDigits: "फोन नंबर 10 अंकों का होना चाहिए",
      phoneValidationStart: "6, 7, 8 या 9 से शुरू होना चाहिए",
      indiaEmergencyNumbers: "भारत आपातकाल नंबर:",
      number112Desc: "112 — राष्ट्रीय एकल आपातकाल नंबर (दुर्घटना, बचाव, कोई आपातकाल)",
      number108Desc: "108 — एम्बुलेंस (चिकित्सा आपातकाल)",
      number100Desc: "100 — पुलिस",
    },
    rescue: {
      title: "प्राथमिक चिकित्सा मार्गदर्शन",
      subtitle: "एम्बुलेंस की प्रतीक्षा करते हुए इन चरणों का पालन करें",
      rewardBanner: "आप राह-वीर के रूप में कार्य कर रहे हैं! Rs.25,000 पुरस्कार + कानूनी प्रतिरक्षा के पात्र",
      danger: "खतरा",
      dangerDesc: "जांचें कि क्या क्षेत्र आपके पास जाने के लिए सुरक्षित है। यातायात, आग या बिजली के खतरों की तलाश करें।",
      response: "प्रतिक्रिया",
      responseDesc: "धीरे से व्यक्ति के कंधों को थपथपाएं और जोर से पूछें: 'क्या आप ठीक हैं? क्या आप मुझे सुन सकते हैं?'",
      airway: "वायुमार्ग",
      airwayDesc: "सिर को धीरे से पीछे झुकाएं और ठुड्डी को ऊपर उठाएं। मुंह से दिखाई देने वाली किसी भी रुकावट को हटाएं।",
      breathing: "श्वास",
      breathingDesc: "10 सेकंड तक छाती की गति देखें, सांस की आवाज सुनें, और अपने गाल पर हवा महसूस करें।",
      circulation: "रक्त संचार",
      circulationDesc: "गंभीर रक्तस्राव की जांच करें। यदि खून बह रहा है, तो साफ कपड़े से मजबूत, निरंतर दबाव लगाएं।",
      cprTitle: "सीपीआर निर्देश",
      cprDesc: "यदि सांस नहीं चल रही: छाती के बीच में जोर से और तेज दबाएं। 30 दबाव, फिर 2 बचाव श्वास। दोहराएं।",
      bleedingTitle: "रक्तस्राव नियंत्रण",
      bleedingDesc: "साफ कपड़े से सीधा, निरंतर दबाव लगाएं। कपड़ा न हटाएं। जरूरत हो तो और परतें जोड़ें।",
      fractureTitle: "फ्रैक्चर सहायता",
      fractureDesc: "घायल अंग को लकड़ी के ब्लॉक, छतरी या मुड़े हुए अखबार से सहारा दें। अंग को सीधा करने की कोशिश न करें।",
      neckWarning:
        "बेहोश व्यक्ति को गर्दन को सहारा दिए बिना कभी न हिलाएं। रीढ़ की हड्डी की चोटें स्थायी पक्षाघात का कारण बन सकती हैं।",
      completed: "पूरा हुआ",
      primarySurveyTitle: "प्राथमिक सर्वेक्षण (DRABC)",
      primarySurveySubtitle: "प्रत्येक चरण का क्रम में पालन करें",
      criticalInterventions: "महत्वपूर्ण हस्तक्षेप",
      goldenHourSubtitle: "गोल्डन ऑवर कार्रवाइयां",
      markAsDone: "पूरा हुआ मार्क करें",
      rewardEligibleShort: "Rs.25,000 पुरस्कार + पूर्ण कानूनी प्रतिरक्षा के पात्र",
      completeMoreSteps: "राह-वीर स्थिति के लिए {{n}} और चरण पूरे करें",
      disclaimer:
        "MoHFW और सेंट जॉन एम्बुलेंस प्रोटोकॉल के आधार पर निर्देश। संदेह की स्थिति में, पेशेवर मदद की प्रतीक्षा करें।",
      poweredBy: "EmergencyQR.in द्वारा संचालित",
      typeMedical: "चिकित्सा आपातकाल — CPR और श्वास पर ध्यान दें",
      typeAccident: "दुर्घटना — रक्तस्राव नियंत्रण पर ध्यान दें",
      typeFire: "आग/अन्य — जलने और रक्तस्राव की जांच करें",
      whatsappNotify: "WhatsApp से सूचित करें",
      showAllSteps: "सभी चरण देखें",
      showLess: "कम दिखाएं",
    },
    guide: {
      back: "होम पर वापस",
      backShort: "होम",
      navOrder: "अपना QR स्टिकर ऑर्डर करें {{price}}",
      needHelp: "मदद चाहिए?",
      shareWhatsApp: "WhatsApp पर साझा करें",
      badge: "SOS",
      title: "आपातकालीन QR सेटअप गाइड",
      subtitleBefore: "दो मिनट से कम में अपना QR सेट करें",
      subtitleHighlight: "",
      readTime: "अनुमानित समय: 2 मिनट",
      download: "PDF डाउनलोड करें",
      downloading: "PDF बन रहा है…",
      progressLabel: "गाइड प्रगति",
      stepTime: "{{time}}",
      hindiLabel: "हिंदी",
      steps: {
        s1: {
          title: "यह QR कोड स्टिकर क्या है?",
          imageAlt: "आपातकालीन QR स्टिकर पकड़े भारतीय परिवार",
          titleHi: "यह QR स्टिकर क्या है?",
          body: "एक छोटा वॉटरप्रूफ स्टिकर जिस पर अनोखा QR कोड है। कोई भी फोन से स्कैन करे तो तुरंत आपकी आपातकालीन जानकारी दिखती है — कोई ऐप जरूरी नहीं।",
          bodyHi:
            "यह एक छोटा वॉटरप्रूफ स्टिकर है जिस पर अनोखा QR कोड है। कोई भी मोबाइल से स्कैन करे तो तुरंत आपकी आपातकालीन जानकारी दिखती है — कोई ऐप जरूरी नहीं।",
          time: "20 सेकंड",
          highlights: [],
        },
        s2: {
          title: "QR कोड स्कैन करें",
          imageAlt: "हेलमेट पर QR कोड स्कैन करता स्मार्टफोन",
          titleHi: "QR कोड कैसे स्कैन करें",
          body: "किसी भी Android या iPhone पर कैमरा खोलें और QR कोड पर पॉइंट करें। दिखने वाले लिंक पर टैप करें — प्रोफाइल तुरंत खुल जाती है।",
          bodyHi:
            "किसी भी Android या iPhone पर कैमरा खोलें और QR कोड पर पॉइंट करें। स्क्रीन पर दिखने वाले लिंक पर टैप करें — आपकी प्रोफाइल तुरंत खुल जाती है।",
          time: "15 सेकंड",
          highlights: [],
        },
        s3: {
          title: "अपनी जानकारी सेट करें",
          imageAlt: "स्मार्टफोन पर आपातकालीन प्रोफाइल सेटअप",
          titleHi: "अपनी जानकारी सेट करें",
          body: "अपना स्टिकर स्कैन करें और 'सेट अप' पर टैप करें। ब्लड ग्रुप, एलर्जी, दवाइयां और आपातकालीन संपर्क जोड़ें — लगभग दो मिनट लगते हैं।",
          bodyHi:
            "अपना स्टिकर स्कैन करें और 'सेट अप' पर टैप करें। ब्लड ग्रुप, एलर्जी, दवाइयां और आपातकालीन संपर्क जोड़ें — लगभग दो मिनट लगते हैं।",
          time: "45 सेकंड",
          highlights: ["ब्लड ग्रुप", "एलर्जी", "दवाइयां", "आपातकालीन संपर्क"],
          highlightsHi: ["ब्लड ग्रुप", "एलर्जी", "दवाइयां", "आपातकालीन संपर्क"],
        },
        s4: {
          title: "आपातकाल में",
          imageAlt: "सड़क पर आपातकाल में QR कोड स्कैन",
          titleHi: "आपातकाल में क्या होता है",
          body: "अगर आप घायल या बेहोश हैं, कोई भी राहगीर या पैरामेडिक स्टिकर स्कैन करके तुरंत ब्लड ग्रुप, आपातकालीन संपर्क और बीमारियां देख सकता है।",
          bodyHi:
            "अगर आप घायल या बेहोश हैं, कोई भी राहगीर या पैरामेडिक आपका स्टिकर स्कैन करके तुरंत ब्लड ग्रुप, आपातकालीन संपर्क और बीमारियां देख सकता है।",
          time: "20 सेकंड",
          highlights: ["ब्लड ग्रुप"],
          highlightsHi: ["ब्लड ग्रुप"],
        },
        s5: {
          title: "जोड़ने के लिए सुझाई गई जानकारी",
          imageAlt: "ब्लड ग्रुप, एलर्जी और संपर्क दिखाती आपातकालीन प्रोफाइल",
          titleHi: "जोड़ने के लिए सुझाई गई जानकारी",
          body: "ब्लड ग्रुप, डॉक्टर का फोन नंबर, रोज़ की दवाइयां, ज्ञात एलर्जी और आपातकालीन संपर्क (परिवार का सदस्य)। जितनी पूरी प्रोफाइल, उतनी तेज़ मदद।",
          bodyHi:
            "ब्लड ग्रुप, डॉक्टर का फोन नंबर, रोज़ की दवाइयां, ज्ञात एलर्जी और आपातकालीन संपर्क (परिवार का सदस्य)। जितनी पूरी प्रोफाइल, उतनी तेज़ मदद।",
          time: "30 सेकंड",
          highlights: ["ब्लड ग्रुप", "दवाइयां", "एलर्जी", "आपातकालीन संपर्क"],
          highlightsHi: ["ब्लड ग्रुप", "दवाइयां", "एलर्जी", "आपातकालीन संपर्क"],
        },
      },
      cta: {
        title: "आज ही अपने परिवार की सुरक्षा करें",
        subtitle: "अपना आपातकालीन QR स्टिकर पाएं और किसी भी आपातकाल के लिए तैयार रहें।",
        order: "अपना QR स्टिकर ऑर्डर करें",
        demo: "डेमो देखें",
        priceNote: "{{price}} से शुरू",
        completeBadge: "आप तैयार हैं",
        completeLead: "अब आप जानते हैं कि EmergencyQR कैसे काम करता है।",
        completeBody: "सिर्फ {{price}} में खुद और परिवार को सुरक्षित करें।",
        trust1: "एक बार की खरीद",
        trust2: "12 महीने का प्रीमियम शामिल",
        trust3: "मुफ्त जानकारी हमेशा दिखेगी",
        trustSocial: "भारत भर के परिवारों द्वारा विश्वसनीय",
      },
      footer: {
        title: "अभी भी सवाल हैं?",
        helpNote: "हम आपकी मदद के लिए यहां हैं।",
        contact: "संपर्क करें",
        whatsapp: "WhatsApp पर चैट करें",
        email: "ईमेल करें",
        emailAddress: "support@emergencyqr.in",
        responseNote: "हम 24 घंटे में जवाब देते हैं",
      },
    },
    faq: {
      badge: "और जानें",
      title: "अक्सर पूछे जाने वाले प्रश्न",
      subtitle: "अपना आपातकालीन QR स्टिकर ऑर्डर करने से पहले आपको जो कुछ जानना चाहिए।",
      q1: "EmergencyQR कैसे काम करता है?",
      a1: "आपको एक टिकाऊ QR स्टिकर मिलता है जिसे आप अपने वाहन, हेलमेट या आईडी कार्ड पर लगाते हैं। जब कोई स्कैन करता है तो आपकी आपातकालीन चिकित्सा जानकारी, संपर्क और 112, 108 (एम्बुलेंस) और 100 (पुलिस) पर कॉल करने का एक-टैप एक्सेस दिखता है।",
      q2: "मुझे अपने प्रोफाइल में कौन सी जानकारी जोड़नी चाहिए?",
      a2: "हम ब्लड ग्रुप, ज्ञात एलर्जी, चिकित्सा स्थितियां (मधुमेह, हृदय रोग आदि), फोन नंबर के साथ आपातकालीन संपर्क और अपने पसंदीदा अस्पताल को जोड़ने की सलाह देते हैं। आप नियंत्रित करते हैं कि स्कैनर को क्या दिखे।",
      q3: "क्या मेरा चिकित्सा डेटा सुरक्षित है?",
      a3: "सभी चिकित्सा डेटा आराम के समय AES-256-GCM एन्क्रिप्शन से सुरक्षित है। हम DPDPA 2023 (भारत का डेटा संरक्षण अधिनियम) का पालन करते हैं। आप प्रत्येक जानकारी की दृश्यता नियंत्रित कर सकते हैं और किसी भी समय अपना प्रोफाइल हटा सकते हैं।",
      q4: "राह-वीर पुरस्कार क्या है?",
      a4: "भारत के गुड समारिटन नियमों के तहत, दुर्घटना पीड़ित की मदद करने वाले राहगीर राज्य राह-वीर या PM-RAHAT मान्यता (अक्सर ₹25,000 तक) और कानूनी सुरक्षा के पात्र हो सकते हैं, जब वे आधिकारिक दिशानिर्देशों का पालन करें। दावा राज्य प्राधिकरण और 112 ERSS के माध्यम से होता है — अभी EmergencyQR के माध्यम से नहीं।",
      q5: "क्या मैं अपने परिवार के लिए प्रोफाइल प्रबंधित कर सकता हूं?",
      a5: "हां। फैमिली पैक में 4 स्टिकर आते हैं। परिवार का हर सदस्य अपना स्टिकर स्कैन करके अपने फोन नंबर से सेट करता है, इसलिए हर स्टिकर की अपनी प्रोफाइल होती है। हर स्टिकर को सेटअप के दिन से 12 महीने का प्रीमियम मिलता है, और फैमिली प्रीमियम 4 स्टिकर तक एक साथ रिन्यू करता है।",
      q6: "इसकी लागत कितनी है?",
      a6Individual: "व्यक्तिगत स्टिकर",
      a6IndividualTail: "लॉन्च कीमत पर, 12 महीने के प्रीमियम के साथ।",
      a6Family: "फैमिली पैक (4 स्टिकर)",
      a6End: "। कोई छिपी फीस नहीं, पहले साल के लिए कोई आवर्ती शुल्क नहीं।",
    },
    shared: {
      loading: "लोड हो रहा है...",
      error: "कुछ गलत हो गया",
      back: "वापस",
      next: "अगला",
      submit: "जमा करें",
      cancel: "रद्द करें",
      save: "सहेजें",
      delete: "हटाएं",
      edit: "संपादित करें",
      close: "बंद करें",
      poweredBy: "EmergencyQR.in द्वारा संचालित",
    },
  },
};

export const t = (key, lang = "en") => {
  const keys = key.split(".");
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      result = translations.en;
      for (const fallbackKey of keys) {
        if (result && result[fallbackKey] !== undefined) {
          result = result[fallbackKey];
        } else {
          return key;
        }
      }
      return result;
    }
  }
  return result;
};

export const getBilingual = (enKey, hiKey, lang = "en") => {
  const en = t(enKey, "en");
  const hi = t(hiKey || enKey, "hi");
  if (lang === "both") return { en, hi };
  return lang === "hi" ? hi : en;
};

export default translations;
